var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseHero({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_484",
    "data-name": "Group 484",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 555.269,
    height: 392.724,
    viewBox: "0 0 555.269 392.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 555.269,
    height: 392.724,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 8.147,
    height: 7.965,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 88.212,
    height: 14.906,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 10.578,
    height: 18.459,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 31.734,
    height: 23.269,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 85.011,
    height: 19.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 29.681,
    height: 23.092,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5322",
    "data-name": "Path 5322",
    d: "M55.081,38.757a9.438,9.438,0,1,1,9.426-9.45,9.436,9.436,0,0,1-9.426,9.45M455.566,264.9a25.853,25.853,0,0,1,0-51.706h3.083a26.873,26.873,0,0,0,0-53.745H398.908s-43.7-2-52.092-26.969c-8.422-24.971-15.2-37.522-63.235-37.522H248.006a17.831,17.831,0,0,1,0-35.662h11.816a12.314,12.314,0,0,0,0-24.627H186.5c-31.606,0-33-14.786-45.525-14.786H81.533a9.438,9.438,0,0,0,0,18.876H90.59a13.658,13.658,0,1,1,0,27.315H39.222a35.108,35.108,0,1,0,0,70.216H79.842a33.763,33.763,0,1,1,0,67.526,79.855,79.855,0,0,0,0,159.709h426.11a49.312,49.312,0,1,0,0-98.623Z",
    transform: "translate(0 23.995)",
    fill: "#ead6d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 45.774,
    height: 30.374,
    transform: "translate(244.473 0.362)",
    fill: "#f1f8fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M110.973,0h45.774a.363.363,0,0,1,.371.362V30.736a.378.378,0,0,1-.371.386H110.973a.376.376,0,0,1-.362-.386V.362A.361.361,0,0,1,110.973,0m45.412.733H111.344V30.374h45.041Z",
    transform: "translate(133.5)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M122.005.164,101.47,12.788v17.75h20.536Z",
    transform: "translate(122.467 0.198)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M121.841,1.022,102.029,13.186V30.374h19.812ZM101.466,12.688,122,.04a.951.951,0,0,1,.2-.04.363.363,0,0,1,.371.362V30.736a.378.378,0,0,1-.371.386H101.667a.376.376,0,0,1-.362-.386V12.986a.319.319,0,0,1,.161-.3",
    transform: "translate(122.268)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M140.584,32.333H199.69V220.847c-17.662,8.148-37.7,13.968-59.106,17.75Z",
    transform: "translate(169.676 39.024)",
    fill: "#f1f8fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    "data-name": "Path 5327",
    d: "M140.782,32.166h59.106a.364.364,0,0,1,.369.371V220.865l-.733.346V32.9H141.153V238.753l-.733.121V32.537a.363.363,0,0,1,.362-.371",
    transform: "translate(169.478 38.822)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5328",
    "data-name": "Path 5328",
    d: "M155.082,32.333l-26.51,16.294v193.6c9.009-.894,17.863-2.077,26.51-3.63Z",
    transform: "translate(155.178 39.024)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5329",
    "data-name": "Path 5329",
    d: "M154.923,33.2,129.137,49.031V242.407l-.733.064V48.831a.387.387,0,0,1,.161-.322l26.519-16.294a.607.607,0,0,1,.2-.049.365.365,0,0,1,.371.371V238.753l-.733.121Z",
    transform: "translate(154.975 38.822)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5330",
    "data-name": "Path 5330",
    d: "M144.338,36.9h9.379V229.41c-3.076.748-6.208,1.434-9.379,2.1Z",
    transform: "translate(174.206 44.541)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5331",
    "data-name": "Path 5331",
    d: "M151.845,36.9h9.4V224.847c-3.074.958-6.23,1.867-9.4,2.737Z",
    transform: "translate(183.267 44.541)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5332",
    "data-name": "Path 5332",
    d: "M159.352,36.9h9.4v182.01c-3.076,1.256-6.208,2.414-9.4,3.533Z",
    transform: "translate(192.327 44.541)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5333",
    "data-name": "Path 5333",
    d: "M108.48,7.992h59.106V269.851a406.95,406.95,0,0,1-56.433,3.736c-.894,0-1.788,0-2.673-.015Z",
    transform: "translate(130.928 9.646)",
    fill: "#f1f8fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5334",
    "data-name": "Path 5334",
    d: "M108.678,7.828h59.106a.355.355,0,0,1,.362.362V270l-.733.088V8.552H109.04V273.77h-.724V8.19a.35.35,0,0,1,.362-.362",
    transform: "translate(130.73 9.448)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5335",
    "data-name": "Path 5335",
    d: "M122.983,7.992,96.464,28.166v243.99c8.671.87,17.527,1.344,26.519,1.417Z",
    transform: "translate(116.426 9.646)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5336",
    "data-name": "Path 5336",
    d: "M122.819,8.923,97.026,28.549V272.4l-.726-.073V28.364a.334.334,0,0,1,.137-.274L122.931,7.916a.318.318,0,0,1,.249-.088.355.355,0,0,1,.362.362V273.77h-.724Z",
    transform: "translate(116.228 9.448)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 30.703)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 9.402,
    height: 27.838,
    transform: "translate(263.841 30.703)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.433 30.703)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 67.122)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 9.402,
    height: 27.838,
    transform: "translate(263.841 67.122)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.433 67.122)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 103.565)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 9.402,
    height: 27.838,
    transform: "translate(264.26 102.987)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.852 102.987)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 139.986)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 9.402,
    height: 27.838,
    transform: "translate(264.26 139.408)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.852 139.408)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 9.404,
    height: 27.814,
    transform: "translate(247.274 175.431)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 9.402,
    height: 27.814,
    transform: "translate(264.26 175.851)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 9.379,
    height: 27.814,
    transform: "translate(280.852 175.851)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 211.85)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 9.402,
    height: 27.838,
    transform: "translate(264.26 212.27)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.852 212.27)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 9.404,
    height: 27.838,
    transform: "translate(247.274 248.269)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 9.402,
    height: 27.838,
    transform: "translate(263.841 248.269)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 9.379,
    height: 27.838,
    transform: "translate(280.852 248.691)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5337",
    "data-name": "Path 5337",
    d: "M75.691,32.333H134.8V243.8a258.788,258.788,0,0,1-59.106-9.79Z",
    transform: "translate(91.354 39.024)",
    fill: "#f1f8fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5338",
    "data-name": "Path 5338",
    d: "M75.889,32.166H135a.363.363,0,0,1,.362.371V244c-.225,0-.475-.015-.724-.015V32.9H76.26V234.31c-.258-.073-.483-.137-.733-.21V32.537a.363.363,0,0,1,.362-.371",
    transform: "translate(91.156 38.822)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5339",
    "data-name": "Path 5339",
    d: "M90.194,32.333,63.675,48.627v175.5a196.232,196.232,0,0,0,26.519,9.878Z",
    transform: "translate(76.852 39.024)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5340",
    "data-name": "Path 5340",
    d: "M90.03,33.2,64.244,49.031V224.5c-.249-.113-.483-.234-.733-.346V48.831a.414.414,0,0,1,.185-.322L90.215,32.215a.378.378,0,0,1,.177-.049.365.365,0,0,1,.371.371V234.31c-.258-.073-.483-.137-.733-.21Z",
    transform: "translate(76.654 38.822)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 41.846,
    height: 9.404,
    transform: "translate(175.674 114.233)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 41.846,
    height: 9.379,
    transform: "translate(175.674 97.666)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 41.846,
    height: 9.404,
    transform: "translate(175.674 81.074)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 41.846,
    height: 9.379,
    transform: "translate(175.674 163.889)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 41.846,
    height: 9.402,
    transform: "translate(175.674 147.297)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 41.846,
    height: 9.395,
    transform: "translate(175.674 130.737)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 41.846,
    height: 9.395,
    transform: "translate(175.674 213.525)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 41.846,
    height: 9.404,
    transform: "translate(175.674 196.958)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 41.846,
    height: 9.402,
    transform: "translate(175.674 180.39)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 41.846,
    height: 9.402,
    transform: "translate(175.674 263.181)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 41.846,
    height: 9.402,
    transform: "translate(175.674 246.614)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 41.846,
    height: 9.379,
    transform: "translate(175.674 230.046)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_697",
    "data-name": "Rectangle 697",
    width: 35.92,
    height: 9.379,
    transform: "translate(249.359 4.515)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5341",
    "data-name": "Path 5341",
    d: "M158.118,115.267s-.2,2.214-2.487,7.011c0,0-1.046,3.26,5.844,8.148s.185-15.159.185-15.159Z",
    transform: "translate(187.768 139.12)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5342",
    "data-name": "Path 5342",
    d: "M181.922,76.711s-3.88,20.7-8.106,42.353c-4.582,23.506-9.58,48.124-10.474,48.422-1.73.572-4.379-1.69-5.522-4.564-.909-2.3-2.5-21.286-1.435-33.587a63.371,63.371,0,0,1,.911-6.987c1.739-7.753,2.262-35.212,7.413-39.52,5.184-4.315,17.212-6.118,17.212-6.118",
    transform: "translate(188.317 92.585)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5343",
    "data-name": "Path 5343",
    d: "M181.727,76.711s-2.238,11.94-5.16,27.154c-.934,4.813-1.916,9.973-2.946,15.2-4.131,8.1-7.665,13.6-8.759,12.573-2.262-2.125-6.182-2.375-8.671-2.3a63.371,63.371,0,0,1,.911-6.987c.137-.587.274-1.344.386-2.165,1.465-9.766,2.286-33.384,7.027-37.355,5.184-4.315,17.212-6.118,17.212-6.118",
    transform: "translate(188.512 92.585)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M176.565,96.464c-.934,4.813-1.916,9.975-2.946,15.2-4.129,8.1-7.665,13.606-8.759,12.575-2.262-2.125-6.182-2.375-8.669-2.3a64.078,64.078,0,0,1,.909-6.989c.137-.587.274-1.344.386-2.165L169.9,82.843Z",
    transform: "translate(188.512 99.986)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M184.956,83.878a89.793,89.793,0,0,0-.547-13.372l-16.68,2.721s0,5.087.073,10.748c0,0-.459,5.224,5.972,6,6.464.781,11.344-2.028,11.183-6.093",
    transform: "translate(202.438 85.096)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M172.744,181.718a30.2,30.2,0,0,1,2-7.534c1.417-2.809,10.362-1.024,10.362-1.024s1.788,1.523,2.174,8.7Z",
    transform: "translate(208.491 208.318)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M174.741,184.974c2.1-1.3.909-10.867.909-10.867s-9.786-7.826-11.132-1.83-9.307,8.68-13.831,9.428c-3.125.508-4.1,2.238-4.405,3.268Z",
    transform: "translate(176.554 205.199)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M186.374,184.424a44.368,44.368,0,0,0-.733,5.272c-.885,17.775-14.926,58.349-17.452,59.307-3.88,1.465-10-1.666-13.2-2.673a2.741,2.741,0,0,1-1.916-3.123c6.939-31.945,9.492-77.951,10.426-105.2a121.923,121.923,0,0,1,2.834-23.184s34.23-9.121,34.415,2.423c.177,10.223-11.319,50.314-14.378,67.179",
    transform: "translate(184.686 134.453)",
    fill: "#3e62ac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M180.641,184.424l-22.87-46.418a121.923,121.923,0,0,1,2.834-23.184s34.23-9.121,34.415,2.423c.177,10.223-11.319,50.314-14.378,67.179",
    transform: "translate(190.419 134.453)",
    fill: "#4f0e16",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5350",
    "data-name": "Path 5350",
    d: "M164.679,116.357l18.1,131.14s7.938,1.916,14.129.369c0,0,5.288-69.739,4.853-86.6-.45-16.865,3.818-45.114-.958-48.237-4.789-3.107-36.121,3.332-36.121,3.332",
    transform: "translate(198.757 135.39)",
    fill: "#6d2d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5351",
    "data-name": "Path 5351",
    d: "M210.845,155.83a2.706,2.706,0,0,1-2.664,2.8l-28.531.433-20.946.322c-.982.024,2.125-7.824,2.189-58.991.024-11.408,17.686-23.685,18.033-23.685,0,1.642,2.576,4.679,6.568,4.926,4.749.322,10.547-2.028,10.547-4.765a14.117,14.117,0,0,1,1.432,1.843c2.375,3.447,7.148,11.851,10.183,26.479,2.392,11.544,1.483,26.993,3.189,46.917.137,1.432-.04,2.712,0,3.719",
    transform: "translate(191.314 92.585)",
    fill: "#fff0f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5352",
    "data-name": "Path 5352",
    d: "M209.775,158.791a58.649,58.649,0,0,1-10.885,3.171,108.118,108.118,0,0,1-21.059,2.125c-13.879.064-19.128-4.7-19.128-4.7-.982.024,2.125-7.826,2.189-58.994.024-11.408,17.686-23.683,18.033-23.683,0,0-.459,15.2,4.129,19.666,0,0,6.457-4.99,14.828-19.167,2.353,3.445,6.738,13.354,9.775,27.982a84.378,84.378,0,0,1,1.3,9.717c.8,10.088.62,22.411,1.891,37.2.137,1.435-.04,2.715,0,3.721.049,1.529.459,2.937-1.07,2.962",
    transform: "translate(191.314 92.585)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5353",
    "data-name": "Path 5353",
    d: "M190.662,143.141a58.651,58.651,0,0,1-10.885,3.171c-2.214-3.4-5.023-9.538-5.409-19.216-.66-16.358,14.877-37.419,14.877-37.419l.6,9.58c.8,10.088.62,22.411,1.891,37.2.137,1.435-.04,2.715,0,3.721.049,1.529.459,2.937-1.07,2.962",
    transform: "translate(210.426 108.235)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5354",
    "data-name": "Path 5354",
    d: "M190.117,88.8l-26.47,15.312,20.973,36.331,26.492-15.3Z",
    transform: "translate(197.511 107.175)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5355",
    "data-name": "Path 5355",
    d: "M209.026,137.3a81.222,81.222,0,0,1-14.725-.435,140.965,140.965,0,0,1-25.486-5.129l2.962-5.047s12.076-.523,20.931-1.827a50.75,50.75,0,0,0,5.773-1.11c1.916-.508-7.625-24.715-12.463-38.933-1.143-3.405-2-6.23-2.414-8.033,0,0,.845.137,2.165.386,3.743.757,11.383,2.487,14.628,4.95,4.379,3.31,15.336,40.711,8.629,55.178",
    transform: "translate(203.75 92.673)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5356",
    "data-name": "Path 5356",
    d: "M177.1,101.491s-4.089-3.831-5.659-3.831-6.144,1.666-6.619,2.946c-.459,1.271-.644,3.582.66,4.081a60.892,60.892,0,0,0,8.1,1.916c1.393.137,4.838-.636,3.518-5.111",
    transform: "translate(198.52 117.869)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5357",
    "data-name": "Path 5357",
    d: "M199.931,137.113a81.222,81.222,0,0,1-14.725-.435,17.458,17.458,0,0,0-1.593-12,50.75,50.75,0,0,0,5.773-1.11c1.916-.508-7.625-24.715-12.463-38.933-.362-4.613-.572-7.7-.572-7.7l.322.049c3.743.757,11.383,2.487,14.628,4.95,4.379,3.31,15.336,40.711,8.629,55.178",
    transform: "translate(212.845 92.858)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5358",
    "data-name": "Path 5358",
    d: "M169.633,97.213s12.913-5.676,13.1-6.133a10.177,10.177,0,0,0-1.529-4.913s6.182.572,6.568-.2c.4-.757.532-7.139.532-7.139a9.938,9.938,0,0,0-5.643-2.809s-2.776,6.914-3.831,8.991c-2.739,5.5-9.194,12.2-9.194,12.2",
    transform: "translate(204.736 91.749)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5359",
    "data-name": "Path 5359",
    d: "M171.93,85.983s.821,6.641,3.059,11.247c0,0-6.729-4.694-7.3-6.224s1.618-4.524,1.618-4.524-4.017-.088-4.1-1.408c-.1-1.353,1.231-6.619,1.231-6.619s3.469-2.536,4.427-2.447Z",
    transform: "translate(199.38 91.733)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5360",
    "data-name": "Path 5360",
    d: "M186.415,65.335c-5.5-7.689-18.468-5.749-19.973,6.023-.587,4.774.258,12.123,2.335,16.55a17.513,17.513,0,0,0,2.052,2.737,6.839,6.839,0,0,0,3.05,2.514c2.995.821,5.934,1.183,8.422-.508a11.182,11.182,0,0,0,3.083-3.286,9.618,9.618,0,0,0,2.028-4.242c1.079-6.987,2.125-15.433-1-19.787",
    transform: "translate(200.665 73.313)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5361",
    "data-name": "Path 5361",
    d: "M165.9,65.436c-1.8,3.856-.322,7.367.21,11.608l.611,5.047c.088-1.095.684-1.867,1.095-3.67.644-2.946,1.256-6.963,2.1-7.376,4.679-2.214,13.645-1.779,17.55.09,1.161.547,2.648,10.657,2.648,10.657,6.892-16.793-2.946-15.923-2.6-19.24-4.548-4.284-17.984-4.831-21.615,2.882",
    transform: "translate(199.18 71.756)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5362",
    "data-name": "Path 5362",
    d: "M166.355,67.958c2.238-.669,2.375,4.01,2.375,6.343.024,4.566-5.893-5.3-2.375-6.343",
    transform: "translate(199.431 81.943)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5363",
    "data-name": "Path 5363",
    d: "M166.047,69.017c.04-.2.362-.113.313.113-.41,1.28,0,2.028.523,2.326a.178.178,0,0,1,.073.234c-.3.523-1.481-.821-.909-2.673",
    transform: "translate(200.222 83.164)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5364",
    "data-name": "Path 5364",
    d: "M178.328,67.926c-2.229-.66-2.366,4.017-2.366,6.343-.024,4.59,5.884-5.3,2.366-6.343",
    transform: "translate(212.374 81.905)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5365",
    "data-name": "Path 5365",
    d: "M177.331,69a.168.168,0,1,0-.322.1c.386,1.271,0,2.028-.523,2.326a.162.162,0,0,0-.073.225c.3.547,1.49-.821.918-2.648",
    transform: "translate(212.897 83.131)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M168.652,74.754a.214.214,0,0,1,.3.04c1.916,2.487,8.7,3.332,11.94-.225.2-.21.5.088.313.274-4.54,8.261-13.573,2.761-12.551-.088",
    transform: "translate(203.455 89.912)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5367",
    "data-name": "Path 5367",
    d: "M188.449,72.135q-4.83-4.866-17.364-.3c-5.272-1.3-6.457-3.743-4.242-7.735,3.171-5.612,9.989-1.161,18.346-6.457-.3,4.1,11.864,7.349,3.26,14.491",
    transform: "translate(200.089 69.573)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5368",
    "data-name": "Path 5368",
    d: "M167.664,64.343A2.029,2.029,0,0,0,168.6,61.9a4.023,4.023,0,0,0-4.217-.064c.8.049,1.891.87,3.284,2.511",
    transform: "translate(198.396 73.944)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5369",
    "data-name": "Path 5369",
    d: "M167.748,63.69c-.684.772-1.322.934-1.891.523a4.547,4.547,0,0,1,.611-3.807c-.088.724.346,1.827,1.28,3.284",
    transform: "translate(199.98 72.906)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5370",
    "data-name": "Path 5370",
    d: "M168.918,62.926c-1.876,1.216-2.439,2.512-1.715,3.88a9.723,9.723,0,0,0,8.419-.064c-1.618-.049-3.855-1.3-6.7-3.816",
    transform: "translate(201.435 75.948)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M170.1,85.79a1.031,1.031,0,0,1,1.031,1.046,1.038,1.038,0,1,1-2.077,0A1.034,1.034,0,0,1,170.1,85.79",
    transform: "translate(204.036 103.543)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M169.663,90.733a1.039,1.039,0,0,1,1.046,1.022,1.051,1.051,0,1,1-2.1,0,1.041,1.041,0,0,1,1.055-1.022",
    transform: "translate(203.499 109.509)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M169.242,105.747a1.038,1.038,0,1,1,0,2.077,1.038,1.038,0,1,1,0-2.077",
    transform: "translate(203.001 127.63)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M169.353,111.423a1.051,1.051,0,1,1-1.055,1.046,1.06,1.06,0,0,1,1.055-1.046",
    transform: "translate(203.125 134.48)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5375",
    "data-name": "Path 5375",
    d: "M174.11,68.113c-1.143-.483-2.174-1.031-3.381-1.481-1.779-.684-2.278.636-3.518.724.283-.152.234-.249.532-.547,1.682-1.666,3.123-1.271,5.038-.338,1.07.523,1.256.249,1.329,1.642",
    transform: "translate(201.813 79.253)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M169.5,66.588a1.168,1.168,0,0,0-1.119,1.207,1.122,1.122,0,1,0,2.238,0,1.174,1.174,0,0,0-1.119-1.207",
    transform: "translate(203.226 80.367)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5377",
    "data-name": "Path 5377",
    d: "M169.5,69a1.153,1.153,0,0,1-1.119-1.207,1.168,1.168,0,0,1,1.119-1.207,1.052,1.052,0,0,1,.684.249h-.1a.363.363,0,0,0-.338.386.374.374,0,0,0,.338.386.378.378,0,0,0,.371-.386v-.04a1.38,1.38,0,0,1,.161.611A1.159,1.159,0,0,1,169.5,69",
    transform: "translate(203.226 80.369)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5378",
    "data-name": "Path 5378",
    d: "M172.092,68.137c1.167-.483,2.2-1.031,3.405-1.49,1.779-.684,2.253.644,3.509.757-.274-.185-.225-.274-.523-.572-1.691-1.666-3.123-1.28-5.038-.346-1.081.532-1.256.258-1.353,1.651",
    transform: "translate(207.704 79.277)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5379",
    "data-name": "Path 5379",
    d: "M174.163,66.61a1.224,1.224,0,0,1,0,2.439,1.224,1.224,0,0,1,0-2.439",
    transform: "translate(208.853 80.394)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5380",
    "data-name": "Path 5380",
    d: "M174.163,69.049a1.224,1.224,0,0,0,0-2.439,1,1,0,0,0-.684.252h.088a.364.364,0,0,1,.346.384.356.356,0,1,1-.708,0V67.2a1.146,1.146,0,0,0-.161.62,1.18,1.18,0,0,0,1.119,1.229",
    transform: "translate(208.853 80.394)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5381",
    "data-name": "Path 5381",
    d: "M171.574,73.408a1.573,1.573,0,0,1-1.117-.532c-.252-.391.117-2.075,1.092-5.005l.007,0h0l0,.009c-.975,2.926-1.344,4.606-1.1,4.992a1.562,1.562,0,0,0,1.11.53c.044,0,.093,0,.141-.009l.007,0-.007.007c-.046,0-.095.009-.143.009",
    transform: "translate(205.638 81.91)",
    fill: "#f09171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5382",
    "data-name": "Path 5382",
    d: "M169.6,72.162q3.188,3.416,6.5,0a31.792,31.792,0,0,1-6.5,0",
    transform: "translate(204.696 87.095)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5383",
    "data-name": "Path 5383",
    d: "M145.3,161.1l.669.636-5.959,6.23s-1.465-1.393-2.445-2.326c-1.395-1.351,15.06-16.431,19.125-17.711l1.282,1.231s-4.429,4.654-6.12,6.393A37.351,37.351,0,0,1,145.3,161.1",
    transform: "translate(165.926 178.544)",
    fill: "#3156a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5384",
    "data-name": "Path 5384",
    d: "M147.646,160.457a36.67,36.67,0,0,0-6.464,5.771c-1.98-1.849-4.332-4.476-6.272-6.528-1.852-2.028,2.6-6,6.53-5.272,5.522-.113,13.1-7,16.2-6.98a3.825,3.825,0,0,1,2.673,1.07s-4.451,4.654-6.118,6.393a40.653,40.653,0,0,1-6.546,5.546",
    transform: "translate(162.305 177.959)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5385",
    "data-name": "Path 5385",
    d: "M116.288,99.13s6.23-6.182,7.051-8.219c1.483-3.785-.618-9.79-.618-9.79s.505-1.432,1.9-.064c1.368,1.368,2.207,5.908,2.207,5.908a64.367,64.367,0,0,1,10.657-4.926c1.9-.644,2.489-.781,3.2-.41.459.2,1.417,1.271-.161,1.931a32.291,32.291,0,0,0-6.643,3.7s.982-.249,1.505,1.137a2.175,2.175,0,0,1-.5,2.037,1.607,1.607,0,0,1,1.095.885,1.527,1.527,0,0,1-.3,1.691s.918,1.167.161,2.052a26.075,26.075,0,0,1-5.908,3.582,7.16,7.16,0,0,1-4.767.274l-4.409,4.244Z",
    transform: "translate(140.352 97.117)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5386",
    "data-name": "Path 5386",
    d: "M115.048,89.914a30.937,30.937,0,0,1,2.986-2.439l5.436,7.413-3.222,2.834Z",
    transform: "translate(138.855 105.577)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5387",
    "data-name": "Path 5387",
    d: "M82.121,150.728a2.81,2.81,0,0,0-.733-.636c.049-.185.121-.435.234-.757.161-.474.362-1.119.636-1.916a4.755,4.755,0,0,1,.684-1.32,1.082,1.082,0,0,1,.6-.435c1.368-.161,3.856-.371,7.462-.644q5.34-.374,14.442-.934a.489.489,0,0,0,.459-.525.458.458,0,0,0-.505-.457c-5.886.369-10.723.66-14.466.934-3.7.274-6.208.483-7.528.644h-.073a2.192,2.192,0,0,0-1.159.821,4.917,4.917,0,0,0-.821,1.569l-.024.024c-.274.821-.483,1.465-.636,1.94-.161.508-.274.845-.322,1.006v.049a.4.4,0,0,0-.088.088,4.944,4.944,0,0,0-.967.8c-8.759,12,6.279,8.993,2.809-.249",
    transform: "translate(92.366 172.716)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5388",
    "data-name": "Path 5388",
    d: "M128.162,170.316a60.128,60.128,0,0,1,8.854,1.07c1.556.274,4.663,1.691,5.323,1.827.636.137,2.375.249,2.326-2.028-.113-4.886-17.139-8.832-20.061-9.289-7.689-1.209-21.036-1.966-21.036-1.966s-8.033-2.125-10.247-2.262c-2.238-.113-4.268.532-9.468,3.019a86.951,86.951,0,0,1,31.171,3.374,114.889,114.889,0,0,1,13.138,6.254",
    transform: "translate(101.205 190.28)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5389",
    "data-name": "Path 5389",
    d: "M93.354,145.938l6.683.386-.227,13.895L91.5,159.4Z",
    transform: "translate(110.437 176.137)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5390",
    "data-name": "Path 5390",
    d: "M92.437,151.511l9.468.547a.66.66,0,0,1,.6.684l-.525,16.543a.6.6,0,0,1-.642.6l-10.426-.6a.631.631,0,0,1-.572-.66l1.457-16.5a.651.651,0,0,1,.644-.611",
    transform: "translate(109.028 182.864)",
    fill: "#c19274",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5391",
    "data-name": "Path 5391",
    d: "M96.687,146.153l5.957-.45a1.485,1.485,0,0,1,1.578,1.368l.45,5.957a1.468,1.468,0,0,1-1.344,1.571l-5.957.457a1.469,1.469,0,0,1-1.569-1.344l-.459-5.957a1.486,1.486,0,0,1,1.344-1.6",
    transform: "translate(115.066 175.85)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5392",
    "data-name": "Path 5392",
    d: "M93.624,145.948l6.658.386-.227,13.895-8.283-.821Z",
    transform: "translate(110.763 176.15)",
    fill: "#f8ebe0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5393",
    "data-name": "Path 5393",
    d: "M154.954,181.039c-1.827-.821-8.759-4.065-13.758-6.047-5-1.964-9.313-3.679-11.642-3.928-2.3-.249-4.129-.748-4.838-.5-.733.249-9.426,7.464-11.913,11.794-2.465,4.315-3.037,5.184-5.564,5.047-2.56-.161-4.129-.073-4.427-.894-1.368-3.743,3.88-10.77,6.069-13.3a51.274,51.274,0,0,0,3.509-4.838c.322-.322-16-1.006-25.647,1.32-1.529.371-18.251,4.977-18.984,1.666a3.975,3.975,0,0,1,2.216-4.515c2.39-1.329,6.5-2.4,10.721-3.332,5.436-1.231,11.48-2.849,16.932-3.7a86.586,86.586,0,0,1,36.951,2.715c4.789,1.481,27.426,13.4,32.49,18.234a4.449,4.449,0,0,1,1.505,2.56c.1,2.278-1.119,2.737-1.119,2.737-8.027.274-6-2.037-12.5-5.023",
    transform: "translate(81.649 191.81)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5394",
    "data-name": "Path 5394",
    d: "M87.806,171.264a4.926,4.926,0,1,1-5.2,4.628,4.927,4.927,0,0,1,5.2-4.628",
    transform: "translate(99.69 206.696)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5395",
    "data-name": "Path 5395",
    d: "M113.836,170.487a4.927,4.927,0,1,1-5.184,4.637,4.926,4.926,0,0,1,5.184-4.637",
    transform: "translate(131.125 205.757)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5396",
    "data-name": "Path 5396",
    d: "M87.535,160.821a4.927,4.927,0,1,1-5.177,4.63,4.924,4.924,0,0,1,5.177-4.63",
    transform: "translate(99.39 194.092)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5397",
    "data-name": "Path 5397",
    d: "M112.6,164.225a4.915,4.915,0,1,1-5.208,4.606,4.886,4.886,0,0,1,5.208-4.606",
    transform: "translate(129.601 198.198)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(210.931 322.944)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5398",
    "data-name": "Path 5398",
    d: "M96.2,152.716l-.459-5.95a1.276,1.276,0,0,1,.024-.435h-.073l-.113,6.956a1.462,1.462,0,0,0,1.505,1.006l5.959-.459a1.463,1.463,0,0,0,.686-.225l-5.961.459a1.443,1.443,0,0,1-1.569-1.353",
    transform: "translate(-95.577 -146.332)",
    fill: "#f6d2b7",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(149.3 350.728)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5399",
    "data-name": "Path 5399",
    d: "M103.408,159.16m-32.5,8.92c2.4-1.32,6.528-2.4,10.723-3.332,5.433-1.231,11.478-2.849,16.938-3.694a86.546,86.546,0,0,1,36.942,2.712c2.849.894,12.068,5.482,20.1,10.064.073-.179.161-.364.249-.547-2.639-1.532-5.449-3.076-8.146-4.493a114.889,114.889,0,0,0-13.138-6.254,97.742,97.742,0,0,0-16.841-3.238,85.224,85.224,0,0,0-14.33-.137c-1.964.137-3.9.362-5.78.66-5.451.847-11.5,2.465-16.929,3.7-4.22.934-8.333,2-10.723,3.332a3.976,3.976,0,0,0-2.214,4.515.849.849,0,0,0,.064.225,8.24,8.24,0,0,1,.781-.289,4.174,4.174,0,0,1,2.3-3.22",
    transform: "translate(-67.65 -158.921)",
    fill: "#f6d2b7",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(184.237 360.185)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M89.775,168.044c-2.189,2.527-7.437,9.556-6.069,13.3a.643.643,0,0,0,.225.322c.161-.088.322-.161.483-.249-.161-3.88,4.315-9.839,6.294-12.14,1.344-1.578,4.91-4.7,2.576-6.069a51.566,51.566,0,0,1-3.509,4.838",
    transform: "translate(-83.481 -163.206)",
    fill: "#f6d2b7",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M92.775,151.529l9.452.556a.705.705,0,0,1,.594.748l-.642,18.708a.672.672,0,0,1-.66.693l-10.41-.6a.662.662,0,0,1-.563-.757l1.569-18.66a.692.692,0,0,1,.66-.693",
    transform: "translate(109.276 182.885)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M136.071,155.2c.982-1.691,5.113-5.683,6.555-9.9,10.406-30.374-37.242-34.23-39.753-14.1-.483,3.882,1.691,8.011,5.747,7.625,4.935-.483,15.159-4.476,20.906-1.94,7.638,3.348,4.156,7.96-1.417,15.151-.772,1.006-1.39,1.852-1.894,2.6Zm-20.286-29.641c4.7-.684,11.253,1.32,14.9,4.081,2.748,2.055,5.619,7.142,5.619,7.142-6.115-7.8-16.8-5.4-23.941-4.354-4.056.611-4.765-2.423-.684-5.3,1.691-1.183,2.787-1.159,4.107-1.569",
    transform: "translate(124.08 143.276)",
    fill: "#f8ebe0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M109.713,128.643c-1.006-1.231-1.256-1.417-1.143-2.35.161-1.031,1.143-3.059,4.588-4.1.572-.161,1.055-.322,1.441-.435a15.593,15.593,0,0,0-2.174.137c-1.32.41-2.414.386-4.1,1.569-4.081,2.873-3.374,5.908.684,5.3.234-.024.483-.073.708-.113",
    transform: "translate(127.438 146.948)",
    fill: "#c8c9ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M121.415,126.264c-5.893-1.642-6.23-1.867-8.194-1.819H113.2a14.644,14.644,0,0,1,10.569,5.425,42.389,42.389,0,0,0-2.35-3.606",
    transform: "translate(136.62 150.19)",
    fill: "#b4b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M132.546,136.467c4.974,7.142,12.414,6.707,12.068,1.095-.748-12.712-27.887-23.822-36.395-20.423-3.037,1.207-2.763,4.813-1.578,6.7.232.41,17.644.781,25.9,12.624",
    transform: "translate(127.703 140.631)",
    fill: "#ee9479",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(240.596 257.173)",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M109.019,116.529c11.527,4.476,25.146,26.768,31.541,22.8a5.071,5.071,0,0,0,.177-1.779c-.662-10.885-20.624-20.584-31.718-21.019",
    transform: "translate(-109.017 -116.53)",
    fill: "#f8ebe0",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M81.183,193.58c-4.266-1.457-5.248-4.041-4.974-8.92.249-4.451.185-27.315-.6-30.6a181.977,181.977,0,0,1-3.736-20.544,160.192,160.192,0,0,1-.483-20.584c.547-9.6,4.107-22.381,14.95-22.341,2.666,0,38.562-4.193,42.514,4.977,1.159,2.7,9.218,35.783,12.229,48.173,1.593,6.616,3.2,10.931,3.533,15.835a21.552,21.552,0,0,1-2.986,13.217c-2.463,4.332-5.3,9.243-5.546,13.694-.614.113-1.073.2-1.322.249a148.107,148.107,0,0,1-15.7.887c-4.822.024-11.8-2.214-16.157-1.41-.483.088-.918.155-1.329.225-1.432.227-2.439.34-3.1.386-2.56-.088-5.208.733-11.617,3.359-.894.362-2.375.313-3.494.934a5.689,5.689,0,0,0-2.141,1.715c-.113.338,0,.386.313.274a4.054,4.054,0,0,0-.362.474",
    transform: "translate(86.004 108.183)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M92.016,179.818a126.5,126.5,0,0,0-1.666-15.272c-3.357-16.47-26.382-62-10.249-72.725,5.458-3.633,26.744-6.184,41.669-2.946,22.5,4.935,14.266,28.416,11.551,48.429-1.94,14.235-4.476,27.106-5.023,28.547-.547,1.41-4.725,12.527-6.294,13.211-1.6.684-15.844,3.558-29.988.757",
    transform: "translate(89.823 105.475)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M80.249,90.813c-1.691,8.742-3.469,15.457-3.132,28.869.669,27.315,12.01,41.627,3.2,72.154-3.533-1.521-4.354-4.081-4.1-8.6.249-4.454.185-27.315-.6-30.6A182.078,182.078,0,0,1,71.876,132.1a160.643,160.643,0,0,1-.483-20.586c.435-7.5,2.69-16.954,8.856-20.7",
    transform: "translate(86.004 109.605)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M95.012,137.575c8.629,4.974,13.356,10.362,17.163,12.14a42.837,42.837,0,0,0,12.986,4.178c4.838.636,19.489,1.8,32.241-.636,12.76-2.423,19.739-5.3,18.668-7.078-6.118-10.134-2.278-8.742-18.37-11.7-20.787-3.816-34.135,5-48.286,2.326-11.842-2.214-19.763-5.957-31.469,1.368a7.015,7.015,0,0,0-2.143,1.715c-.845,2.214,9.443-7.921,19.209-2.311",
    transform: "translate(91.43 161.129)",
    fill: "#ee9479",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M76.707,138.867a4.985,4.985,0,0,0-.934,1.618c-.137.322-1.32,4.29.483,5.773,1.8,1.505,3.533,2.189,6.793,2.189,3.244,0,2.673-3.1,17.324,4.089s11.11,7.574,18.163,8.711c7.1,1.167,49.243.435,54.862-6.321.547-.636,4.129-6.045,3.26-9.289-.845,1.788-7.574,4.2-18.668,6.327-12.752,2.439-27.4,1.271-32.241.636a35.306,35.306,0,0,1-5.862-1.393c-9.861-3.01-14.586-9.355-24.287-14.925-8.325-4.765-17.018,1.876-18.894,2.584",
    transform: "translate(90.841 162.422)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M83.065,134.787c3.268.459,9.611,3.582,11.3,4.749A75.285,75.285,0,0,0,143.4,152.908c6.23-.547,12.825-.894,18.708-3.63,4.114-1.916,9.724-8.808,2.423-12.487-3.083-1.545-8.856-3.26-19.964-3.9a103.925,103.925,0,0,0-24.056,1.779,148.874,148.874,0,0,1-15.7.885c-4.822.024-11.8-2.214-16.157-1.408-4.339.8-5.595.636-5.595.636",
    transform: "translate(100.254 160.247)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(183.319 294.623)",
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M87.331,133.5c5.072,1.666,10.41,4.974,12.824,6.321,14.491,8.1,37.2,11.977,52.971,7.486,3.582-1.006,13.323-3.63,14.917-7.237.4,3.381-2.937,6.866-5.932,8.331-7.479,3.67-21.222,4.789-29.456,4.515-4.816-.161-14.153-1.183-18.185-2.551C101.548,146,92.442,135.2,83.065,133.91a19.763,19.763,0,0,0,4.266-.41",
    transform: "translate(-83.065 -133.498)",
    fill: "#d1a383",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M120.052,162.918l-.249.861-8.261-2.551s.589-1.891,1-3.22c.572-1.843,21.429,6.142,24.376,9.2l-.523,1.708s-6.142-1.894-8.446-2.626a36.72,36.72,0,0,1-7.9-3.372",
    transform: "translate(134.624 190.375)",
    fill: "#3156a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M120.028,166.315a39.123,39.123,0,0,0-8.033-3.2c.642-2.512.892-3.125,2.353-8.051,1-2.56,8.1-2.013,9.2,1.818-.733,6.257,11.222,9.8,12.6,12.551a3.865,3.865,0,0,1,.225,2.882s-6.142-1.9-8.444-2.6a39.14,39.14,0,0,1-7.9-3.405",
    transform: "translate(135.171 185.263)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M110.013,126.669s29.394-1.119,40.76-1.192c5.548-.04,19.988-.274,16.342,15.272-4.228,18.024-20.447,49.83-20.447,49.83L136.6,188.141l13.122-44.615-50.111,2.1s-19.675-16.817,10.4-18.958",
    transform: "translate(112.598 151.436)",
    fill: "#3156a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M87.139,130.808s29.054-1.651,35.187-2.584c.3-.04,3.584,6.093,3.928,6.166,16.406,3.535,28.45,6.731,44.856,17.02,16.64,10.448,29.69,25.333,29.69,25.333l-7.389,8.163s-24.353-18.984-40.961-25.391c-22.138-8.583-48.085-6.488-55.337-10.112-9.379-4.676-9.975-18.6-9.975-18.6",
    transform: "translate(105.171 154.758)",
    fill: "#3e62ac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M105.025,95.86c-1.282-.386-1.046,1.231-3.035,3.147-5.138,5,4.813,25.336,11.3,39.189,3.357,7.181,7.782,10.924,11.776,10.723,3.4-.161,8.035-4.266,5.773-10.635-3.655-10.335-8.238-18.395-13.074-28.5-3.015-6.224-7.329-12.253-12.736-13.919",
    transform: "translate(121.38 115.628)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M120.211,101.729s-9.565-6.826-12.028-7.44l.073,1.805c.137,3.743-.757,7.711-3.743,7.824-3.083.088-10.136-3.606-10.249-7.349l-.064-1.8A6.458,6.458,0,0,0,91.068,96.5L94.65,175.35s6.071-.413,17.23-3.52c9.362-2.6,11.615-7.237,11.615-7.237Z",
    transform: "translate(109.913 113.801)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M101.468,108.053l1.618-7.285-3.992-2.189-3.308,3.9,3.485,5.844s1.6,11.706,2.511,22.478c.87,10.4,2.487,24.85,2.487,24.85l6.071,6.932,1.779-9.854s-2.937-12.937-4.153-18.532c-3.487-16.382-6.5-26.148-6.5-26.148",
    transform: "translate(115.606 118.978)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M102.316,108.428l.024-8.17c-.113-.614-.225-1.234-.346-1.821l.024,8.784-3.074-3.928-.161.733Z",
    transform: "translate(119.225 118.807)",
    fill: "#e9eff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M96.686,106.163l2.052-4.524-.435-.7-1.8,3.734-2.165-3.719c.274.845.523,1.715.775,2.609Z",
    transform: "translate(113.857 121.827)",
    fill: "#a5b8be",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M101.979,103.812l.161-.733-3.469-4.427-.049-.04-2.487,5.136.435.7L98.7,99.731Z",
    transform: "translate(116.029 119.018)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M103.8,96.391l-3.7-2.575-2.825,10.562,6.568,8.419Z",
    transform: "translate(117.402 113.229)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M96.58,88.718l-3.856,11.955s4.443,15.7,8.735,15.1c3.606-.5,3.582-13.758,3.582-13.758s-.724-7.252.4-10.635c1.134-3.357-8.856-2.664-8.856-2.664",
    transform: "translate(111.912 107.006)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M91.079,96.853l3.494-2.834,10.176,10.112-4.315,8.894Z",
    transform: "translate(109.926 113.475)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M83.623,134.96a277.4,277.4,0,0,0,8.122,48.173c4.092,2.8,22.937,4.306,30.078,3.421,0,0-3.882-20.995-7.278-41.281-.8-4.791-1.256-10-1.891-13.05-3.174-15.57-10.885-37.2-10.885-37.2A22.97,22.97,0,0,0,97.7,96.44c-4.749,2.3-16.479,5.859-14.08,38.52",
    transform: "translate(100.541 114.687)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M109.284,137.445a7.049,7.049,0,0,0,1.046-.982,85.421,85.421,0,0,1-3.734-10,12.062,12.062,0,0,1-1.9,1.988c1.691,5.723,3.171,8.009,3.856,8.83.249.049.483.088.733.161",
    transform: "translate(126.361 152.636)",
    fill: "#3156a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M106.829,131.755a2.267,2.267,0,0,0,.347-.225c-.249-.073-.483-.113-.733-.161a2.091,2.091,0,0,0,.386.386",
    transform: "translate(128.47 158.554)",
    fill: "#3156a4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M109.887,162.636a11.934,11.934,0,0,0,1.9-1.988c-.8-2.553-1.6-5.5-2.286-8.72-.73.049-1.417.073-2.1.1a103.029,103.029,0,0,0,2.489,10.611m-4.332-22.59,2.214-.572c-.322-3.22-1.924-18.854-3.88-28.209-.113-.572-.249-1.143-.386-1.706-.121-.572-.258-1.119-.4-1.6-1.022-3.767-1.955-7.075-2.712-9.812v2.463c1.691,9.2,2.946,18.894,3.421,21.913.371,2.189,1.167,12.454,1.739,17.525",
    transform: "translate(121.17 118.455)",
    fill: "#e9eff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M100.584,101.295V98.832c-.113-.435-.225-.863-.346-1.256v1.9c.121.587.234,1.207.346,1.819",
    transform: "translate(120.981 117.768)",
    fill: "#e9eff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M101.061,102.333v-1.9c-.636-2.229-1.11-4.017-1.457-5.224a.075.075,0,0,1-.049.024c.532,2.189,1.031,4.612,1.505,7.1",
    transform: "translate(120.158 114.911)",
    fill: "#e9eff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M118.058,134.7c-1.755,21.244.636,23.983,3.928,26.291,1.271.887-.532,10.927-5.16,14.217a93.769,93.769,0,0,1-7.9-31.016c-.3-4.518-.87-8.1-1.073-10.5-1.441-17.839-8.371-38.948-8.371-38.948a33.7,33.7,0,0,1,4.145,1.137c4.661,1.627,16.826,10.086,14.427,38.818",
    transform: "translate(120.074 114.351)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M106.368,97.125,99.341,94.38s2.052,7.212,5.038,18.121c2.536,9.267,4.725,32.129,4.725,32.129l2.761-28.088-4.628-3.679,3.743-3.284Z",
    transform: "translate(119.898 113.91)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M106.909,119.6a1.22,1.22,0,1,1-2.439.1,1.22,1.22,0,0,1,2.439-.1",
    transform: "translate(126.088 142.955)",
    fill: "#214650",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M107.494,125.429a1.151,1.151,0,0,1-.708,1.441,1.236,1.236,0,0,1-.563-2.375,1.13,1.13,0,0,1,1.271.934",
    transform: "translate(127.282 150.228)",
    fill: "#498ac9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M95.961,114.665l2.624-3.542-4.935-.572.483.894,3.743.459-1.988,2.642a.562.562,0,0,0,.073.119m-4.226-7.583-2.6-10.426,1.715,9.218c.313.386.611.8.885,1.207",
    transform: "translate(107.58 116.657)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M88.96,97.562l6.254-2.922a94.714,94.714,0,0,1,8.1,23.555C105.777,130.7,106.92,145,106.92,145l-12.3-25.81,4.178-5.634-6.029-.708Z",
    transform: "translate(107.369 114.224)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M96.4,110.818c-.024-.04-.024-.064-.04-.088.015.024.015.049.04.088",
    transform: "translate(116.306 133.644)",
    fill: "#a9bbc1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M101.545,118.179h0c-.022,0-.022-.024-.022-.024s0,.024.022.024m-9.2-13.147v-.024c-.088-.137-.185-.289-.274-.45.088.161.185.313.274.475",
    transform: "translate(111.124 126.195)",
    fill: "#001a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M92.268,104.883h0a.531.531,0,0,1-.073-.121v.024c.024.024.049.073.073.1",
    transform: "translate(111.273 126.441)",
    fill: "#000f14",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M101.334,117.842h0a118.369,118.369,0,0,1-9.106-13.025,118.369,118.369,0,0,0,9.106,13.025",
    transform: "translate(111.313 126.507)",
    fill: "#0f343d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M108.605,136.309a28.767,28.767,0,0,0-2.013-2.1c-.708-.611-.934-1.32-.362-1.98a.874.874,0,0,1,.474-.274,2.612,2.612,0,0,1,1.505.435s1.49.724,3.156,1.666a11.451,11.451,0,0,0,.435-2.1c-1.554-3.31-1.578-4.864-3.405-12.076-.024-.04-.024-.064-.04-.088a.024.024,0,0,1-.024-.024,118.369,118.369,0,0,1-9.106-13.025c-.024-.024-.046-.073-.073-.1-.088-.161-8.371-2.439-12.685-3.421-.523,4.153,4.564,7.76,9.514,7.687,3.7-.04,2.924,5.637,3.31,9.267.207,4.749,1.827,11.255,3.606,12.624,1.231.958,3.67,3.284,5.707,3.509",
    transform: "translate(104.315 124.583)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M108.327,124.711l-.508-3.807s-.04-.274-.137-.775a28.094,28.094,0,0,0,.644,4.582",
    transform: "translate(129.966 144.988)",
    fill: "#b3bbbc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5445",
    "data-name": "Path 5445",
    d: "M110.795,129.109c-.589-3.132-1.161-6.729-1.706-10.907-.051-.322-.1-.686-.141-1.073l-1.874.452c.982,4.4,2.1,9.362,2.6,11.567.366,0,.733-.015,1.117-.04m-11.593.55c.821-.346,1.666-.708,2.4-1.055-.274-2.6-.638-6.069-1.009-9.693-.435-.3-.907-.6-1.393-.894a6.315,6.315,0,0,1-1.618,2.216c.547,3.171,1.1,6.343,1.62,9.426",
    transform: "translate(117.775 141.368)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M108.029,128.9c-.5-2.2-1.618-7.164-2.6-11.569l-4.153,1.055a2.381,2.381,0,0,1,.071.45l-1.691.049.024.274c-.225-.161-.481-.338-.733-.5.371,3.624.733,7.093,1.006,9.693a4.207,4.207,0,0,0,.435-.225l.066.684,1.713-.161c.024.249.049.41.049.41s2.465-.04,5.813-.161",
    transform: "translate(119.422 141.616)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5447",
    "data-name": "Path 5447",
    d: "M101.824,129.492c.662-.113,1.32-.274,1.958-.435a25.178,25.178,0,0,0,3.2-1.095c-.525-3.083-1.073-6.254-1.62-9.428a6.6,6.6,0,0,1-3.22,1.554,8.329,8.329,0,0,1-3.831-.274c-1.344.09-2.984.137-4.948.115a3.2,3.2,0,0,0-.459.046,1.313,1.313,0,0,0-1.187,1.209c-.068,1.143,1.258,1.554,1.258,1.554a3.525,3.525,0,0,0-.733.04,1.155,1.155,0,0,0-1.073.918c-.249,1.32,1.461,1.827,1.461,1.827a1.023,1.023,0,0,0-.684.909c-.068,1.006,1.326,1.368,1.326,1.368s-.413,1.095,1.545,1.618a16.462,16.462,0,0,0,7.011.073",
    transform: "translate(110 143.064)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M106.678,129.326a84.473,84.473,0,0,1-1.666-11.842s-.024-.225-.064-.611l-2.214.572c.04.386.088.748.137,1.07.547,4.178,1.119,7.777,1.706,10.909.684-.024,1.368-.049,2.1-.1",
    transform: "translate(123.993 141.057)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5449",
    "data-name": "Path 5449",
    d: "M113.081,129.814l-.026-.159a28.443,28.443,0,0,1-.642-4.582c-.225-1.505-.772-5.087-1.32-9.04l-7.254,1.827-.073.636a84.52,84.52,0,0,0,1.666,11.842c2.511-.115,5.224-.274,7.649-.525m-6.755-8.444a.6.6,0,0,1,.177-.015,1.217,1.217,0,0,1,.249,2.414.445.445,0,0,0-.177.024,1.221,1.221,0,0,1-1.256-1.183,1.2,1.2,0,0,1,1.006-1.24",
    transform: "translate(125.239 140.045)",
    fill: "#498ac9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5450",
    "data-name": "Path 5450",
    d: "M103.8,117.5l.073-.636-.137.024c.04.386.064.611.064.611",
    transform: "translate(125.204 141.045)",
    fill: "#022d36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M105.9,120.86a1.217,1.217,0,0,0-.249-2.414.6.6,0,0,0-.177.015,1.2,1.2,0,0,0-1.006,1.24,1.221,1.221,0,0,0,1.256,1.183.445.445,0,0,1,.177-.024",
    transform: "translate(126.088 142.955)",
    fill: "#022d36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M97.658,119.843a6.307,6.307,0,0,0,1.618-2.214c-.088-.064-.2-.113-.3-.177a5.672,5.672,0,0,1-1.457,1.481c.049.313.088.611.137.909",
    transform: "translate(117.701 141.758)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M98.219,120.587a6.6,6.6,0,0,0,3.22-1.554c-.049-.3-.088-.6-.137-.909a5.18,5.18,0,0,1-1.779.748,4.561,4.561,0,0,1,.5.644.64.64,0,0,0-.177.024c-.137.015-.322.064-.6.113-.274.064-.62.137-1.055.2a32.391,32.391,0,0,1-3.807.459,8.359,8.359,0,0,0,3.831.274",
    transform: "translate(113.92 142.568)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M97,120a5.18,5.18,0,0,0,1.779-.748,5.647,5.647,0,0,0,1.457-1.483c-.338-.185-.66-.393-1-.572-.459,1.435-1.216,2.079-2.052,2.231a3.425,3.425,0,0,1-.708.024c.177.21.362.386.523.547",
    transform: "translate(116.441 141.444)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M98.662,120.581c.836-.152,1.593-.8,2.052-2.229-1.666-.942-3.156-1.668-3.156-1.668a2.6,2.6,0,0,0-1.505-.433.87.87,0,0,0-.474.271c-.572.662-.346,1.371.362,1.982a28.767,28.767,0,0,1,2.013,2.1,3.425,3.425,0,0,0,.708-.024",
    transform: "translate(114.967 140.288)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M98.856,102.542a30.86,30.86,0,0,1,1.8-3.405l7.89,4.676-1.845,3.864Z",
    transform: "translate(119.313 119.652)",
    fill: "#d8ebf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M105.148,111.02l24.941-23.482,6.85,8.419s-17.075,20.352-23.032,24.965c-6.594,5.111-9.629.322-10.562-3.332-.748-2.922,1.8-6.57,1.8-6.57",
    transform: "translate(124.565 105.653)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M92.219,169.229c1.755-.049,4.564-.781,5.707-2.216,1.247-1.554,6.224-7.188,7.985-10.359a51.513,51.513,0,0,0,4.332-9.726,27.932,27.932,0,0,0,1.192-10.538c-2.037-16.865-39.575-25.72-40.146-3.7-.09,3.5,1.785,6.555,5.385,6.917,4.637.483,14.2-3.856,19.587-1.344,7.139,3.308,5.723,8.033.475,15.2-3.123,4.266-5.385,5.723-5.957,8.17-.477,2,.483,5.8.845,7.117.137.547.024.5.6.483m-8.808-42.2c4.427-.708,10.538,1.28,13.959,3.992,2.56,2.061,5.233,7.126,5.233,7.126-5.707-7.762-15.722-5.339-22.436-4.268-3.807.614-4.451-2.4-.611-5.272a9.758,9.758,0,0,1,3.856-1.578",
    transform: "translate(86.037 144.336)",
    fill: "#f8ebe0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M90.138,132.382c-1.715,6.3-6.327,10.377-8.058,12.888-.137.21-.227,1.3.071,1.055,3.286-2.624,6.908-9.677,7.987-13.943",
    transform: "translate(98.912 159.776)",
    fill: "#c8c9ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M81.808,138.638c.459.024.806.684.757,1.457s-.459,1.393-.909,1.368c-.483-.024-.821-.684-.781-1.457.049-.8.483-1.393.934-1.368",
    transform: "translate(97.607 167.327)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M73.312,124.876c.594.024,1.053.748,1.006,1.569-.051.845-.574,1.505-1.185,1.465-.594-.024-1.053-.733-.982-1.578.04-.845.574-1.505,1.161-1.457",
    transform: "translate(87.073 150.714)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M77.74,129.775c-.934-1.231-1.183-1.417-1.07-2.335.161-1.046,1.095-3.05,4.315-4.1.523-.177.982-.316,1.368-.435a10.8,10.8,0,0,0-2.052.137,9.758,9.758,0,0,0-3.856,1.578c-3.84,2.873-3.2,5.884.611,5.272.234-.024.459-.073.684-.113",
    transform: "translate(89.148 148.329)",
    fill: "#c8c9ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M88.708,127.354c-5.539-1.618-5.837-1.852-7.689-1.779H81a13.185,13.185,0,0,1,9.885,5.361s-.918-1.739-2.174-3.582",
    transform: "translate(97.758 151.547)",
    fill: "#b4b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M88.084,126.579c-.92-1.022-8.492-4.354-11.1-5.041-3.008-.821,11.07,4.727,11.1,5.041",
    transform: "translate(92.41 146.589)",
    fill: "#b4b5b5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M79.15,124.427c6.577,1.891,16.278,7.164,20.012,13.074,4.548,7.164,11.642,6.616,11.319,1.031-.66-12.663-26.059-23.621-34.068-20.222-4.356,1.876-2.3,4.637,2.737,6.118",
    transform: "translate(89.356 142.036)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(170.172 259.733)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M77.108,117.689C87.9,122.116,100.592,144.3,106.6,140.3a4.785,4.785,0,0,0,.177-1.779c-.563-10.843-19.28-20.447-29.666-20.833",
    transform: "translate(-77.108 -117.69)",
    fill: "#f8ebe0",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M93.854,116.161c10.386.313,22.089-1.763,33.062-3.743,11.5-1.031,10.659-12.116.073-13.581-6.416-.87-13.645,1.095-29.094-1.3a16.32,16.32,0,0,0-8.951,1.07c-5.041,2.463-4.332,17.252,4.91,17.55",
    transform: "translate(103.594 117.49)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M103.7,92.732c.934-3.43-9.015-2.125-9.015-2.125l-.252,1.006a5.735,5.735,0,0,0,.894,1.818,12.783,12.783,0,0,0,8.1,4.661,19.224,19.224,0,0,1,.274-5.361",
    transform: "translate(113.98 109.063)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M95.58,84.194c-.249-.135-3.582,13.849-.338,18.112,3.26,4.253,10.247,6.257,13.1,3.432,1.417-1.395,4.354-5.387,3.083-10.386-1.329-5.047-.894-10.024-3.816-12.573-5.275-4.566-12.028,1.415-12.028,1.415",
    transform: "translate(113.249 97.836)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M97.993,89.313c-.137,1.739-1.07,3.083-2.077,2.971-1-.073-1.706-1.554-1.545-3.284.137-1.739,1.07-3.059,2.077-2.971,1,.073,1.706,1.554,1.545,3.284",
    transform: "translate(113.873 103.827)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M113.215,104.389q-14.516,3.658-18.057-.821c-2.624-.894-4.153-3.445-4.54-7.665-2.143-6.577,1.231-16.413,4.637-11.028,4.056-7.963,16.543-1.867,24.32-5.725,4.129,3.357,1.739,10.362-1.684,12.463-.708,8.261-1.6,12.615-4.676,12.776",
    transform: "translate(108.56 95.53)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M93.094,83.908c1.095-.693,1.505-1.514,1.231-2.472a4.288,4.288,0,0,0-4.4-.523c.836.137,1.891,1.143,3.171,2.995",
    transform: "translate(108.531 97.188)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M93.477,83.116c-.8.733-1.481.845-2.028.338a4.675,4.675,0,0,1,1.046-3.92c-.185.748.161,1.964.982,3.582",
    transform: "translate(110.29 95.992)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M96.645,83.264c-1.691-.861-3.035-.772-4.065.3-.177,2.648.644,8.082,2.624,9.45.386-.207.87-5.8,1.441-9.748",
    transform: "translate(111.71 99.791)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M96.807,81.818c-3.123,1.167-4.22,2.35-3.332,3.606a24.511,24.511,0,0,0,13.032-.161c-2.487,0-5.734-1.159-9.7-3.445",
    transform: "translate(112.459 98.749)",
    fill: "#09378c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M115.388,93.29c-3.035-3.743-9.329-4.789-18.395-2.463-5.409-1.916-6.382-4.606-3.646-8.534,3.9-5.546,10.584-.185,19.891-4.838-.748,4.266,11.917,9.243,2.15,15.835",
    transform: "translate(110.878 93.483)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M93.691,84.989c2.366-.249,1.682,4.491,1.271,6.819-.821,4.612-4.99-6.409-1.271-6.819",
    transform: "translate(111.243 102.565)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M97.865,109.912c-.894-.177-2.125-1.794-1.916-4.129.161-1.505.3-2.915.313-3.721a25.812,25.812,0,0,1-.547-2.937q-6.942-5.82-1.3-7.7,1.026.725,2.326,4.041a2.27,2.27,0,0,0,2.1-1.119A63.536,63.536,0,0,1,97.7,85.519c2.809-3.372,8.558-3.332,16.02-1.593.161,2.052.225,4.2.225,6.48.845.96,2.15,15.724-7.212,15.378a13.8,13.8,0,0,0-.137,2.536c.1.225-1.505,2.56-.975,2.809-.024-11.867-.137,1.32-7.76-1.216",
    transform: "translate(110.9 99.886)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M116.5,88.6c-7.464-1.739-13.211-1.779-16.02,1.593a63.577,63.577,0,0,0,1.143,8.832,2.27,2.27,0,0,1-2.1,1.119q-1.3-3.32-2.326-4.041-5.651,1.884,1.3,7.7a25.812,25.812,0,0,0,.547,2.937c-4.354-1.432-7.687-5.8-8.051-7.574C86.806,88.41,93.036,84.643,96.3,83.4c2.4-10.024,16.23.426,24.1-3.728,2.529,4.339-1.6,9.064-3.9,8.927",
    transform: "translate(108.128 95.216)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M96.416,92.5a12.671,12.671,0,0,0,4.855,1.521,14.026,14.026,0,0,0-.154,2.061,7.909,7.909,0,0,1-4.7-3.582",
    transform: "translate(116.368 111.644)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M103.707,82.109c1.046.982,1.32,1.982.8,2.986a4.785,4.785,0,0,1-5-.41c.958.051,2.375-.821,4.2-2.576",
    transform: "translate(120.096 99.1)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 85.525,
    height: 111.883,
    transform: "translate(126.821 277.807)",
    fill: "#e26971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M57.729,125.671h85.984V238.5H57.246V125.671Zm85.044.934H58.182V237.529h84.592Z",
    transform: "translate(69.092 151.677)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 168.526,
    height: 111.883,
    transform: "translate(212.347 277.807)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M264.526,126.6H96.942V237.529H264.526Zm-168.043-.934H265.459V238.5H96V125.671Z",
    transform: "translate(115.866 151.677)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M52.614,120.265H144.42v12.39H58.8a6.2,6.2,0,0,1-6.182-6.184Z",
    transform: "translate(63.502 145.152)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M52.872,120.057h92.281V133.38h-86.1a6.691,6.691,0,0,1-6.658-6.658v-6.665Zm91.347.934H53.332v5.731a5.772,5.772,0,0,0,5.725,5.725H144.22Z",
    transform: "translate(63.241 144.901)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M277.864,120.265H94.212v12.39H271.658a6.21,6.21,0,0,0,6.206-6.184Z",
    transform: "translate(113.708 145.152)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M277.641,120.991H94.938v11.456h176.97a5.772,5.772,0,0,0,5.734-5.725Zm-183.178-.934H278.574v6.665a6.643,6.643,0,0,1-1.964,4.694,6.577,6.577,0,0,1-4.7,1.964H94V120.057Z",
    transform: "translate(113.457 144.901)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M102.8,84.392a1.681,1.681,0,0,1,.338-.073,1.017,1.017,0,0,0-.386.049c-.088.024-.113.049-.2.024a.608.608,0,0,1-.21,0,2.255,2.255,0,0,1,.483-.161,2.009,2.009,0,0,0-.386.049c-.121.015-.3.088-.4.088.1-.073.234-.088.3-.137-.137-.024-.313.064-.475.064a1.408,1.408,0,0,1,.274-.177c-.21,0-.523.249-.644.3.049-.073.258-.3.322-.274-.088-.049-.322.137-.386.2-.024,0-.049,0-.049.024-.088.049-.161.137-.249.185a2.558,2.558,0,0,1,.346-.371c.04-.04.088-.064.113-.088a1.676,1.676,0,0,0-.371.249.816.816,0,0,1,.161-.2c-.088,0-.249.177-.322.274-.088.113-.2.289-.274.386a2.133,2.133,0,0,1,.371-.66,1.38,1.38,0,0,0-.3.362l-.21.322a.121.121,0,0,1-.064.113,1.8,1.8,0,0,1,.185-.435c.064-.137.152-.274.177-.346a1.065,1.065,0,0,0-.3.4c-.137.225-.152.362-.249.523a1.769,1.769,0,0,1,.249-.66c-.113.015-.177.225-.274.313.024-.064.073-.137.1-.2a1.776,1.776,0,0,1,.113-.161c-.161.064-.346.572-.41.733a3.284,3.284,0,0,1,.225-.757c-.113.185-.177.362-.249.483.024-.121.073-.234.088-.346a.8.8,0,0,1,.121-.249,4.284,4.284,0,0,0-.371.982,4.647,4.647,0,0,1,.137-.62c-.024.073-.064.161-.088.249-.113.3-.137.644-.225.967a4.855,4.855,0,0,1,.04-.572,2.931,2.931,0,0,1,.161-.483l-.113.185a2.379,2.379,0,0,0-.088.225.928.928,0,0,1-.1.249.846.846,0,0,1-.064.274,2.441,2.441,0,0,1,.113-.547c.049-.161.113-.3.161-.435a2.514,2.514,0,0,0-.3.733,1.833,1.833,0,0,0-.073.684.43.43,0,0,0,.024.185,2.836,2.836,0,0,1,.185-.8,3.052,3.052,0,0,0-.073.66,2.517,2.517,0,0,1,.1-.547,2.178,2.178,0,0,0,.024.572,2.775,2.775,0,0,1,.04-.41,1.369,1.369,0,0,0,.024.45v-.274a.607.607,0,0,1,.049-.289,1.7,1.7,0,0,0,.024.362c.015-.161,0-.3.015-.459a.963.963,0,0,1,.121-.435c-.024.121-.073.322-.1.532a1.4,1.4,0,0,0,0,.45c0-.024.1-.572.113-.66a1.224,1.224,0,0,1,.185-.523c-.024.113-.137.362-.185.547a2.556,2.556,0,0,0-.064.636c.049-.177.049-.435.113-.587a3.374,3.374,0,0,0-.024.5c.024-.113.024-.274.049-.41a1.75,1.75,0,0,1,.113-.362,4.705,4.705,0,0,0-.113.8,2.422,2.422,0,0,0,.088-.234,3.951,3.951,0,0,1,.346-.636,8.4,8.4,0,0,0-.346.772,2.1,2.1,0,0,0,.137-.274,2.439,2.439,0,0,0,.161-.249l-.249.508a3.836,3.836,0,0,1,.66-.733c-.049.049-.088.113-.161.185a5.8,5.8,0,0,0-.41.547c.049-.024.073-.073.113-.121.1-.113.21-.249.3-.338l.049-.024a.527.527,0,0,1-.137.185.338.338,0,0,0-.113.161c.064-.049.3-.322.386-.371l-.049.1a1.146,1.146,0,0,1,.371-.322c-.024.049-.049.049-.073.064a.629.629,0,0,1-.161.185,2.556,2.556,0,0,1,.435-.322c-.064.1-.161.137-.225.234a2.348,2.348,0,0,0,.41-.258c-.024.049-.073.049-.113.121a1.891,1.891,0,0,1,.225-.121l-.088.1c.088-.049.137-.1.2-.137h.049l-.088.088a1.823,1.823,0,0,1,.249-.113c-.024,0-.024,0-.024.024h-.024l-.049.04h-.015v.024a1.858,1.858,0,0,0,.289-.04c.073-.024.185-.1.258-.121l-.049.049-.049.049a.417.417,0,0,1,.185-.049,2.355,2.355,0,0,1,1.457.249,3.926,3.926,0,0,1,.708.572c.137.113.547.508.66.572l-.015-.049c-.024,0-.024,0-.024-.015l-.137-.161c-.073-.073-.113-.161-.185-.234l-.322-.474a3.182,3.182,0,0,0-.636-.6,1.836,1.836,0,0,1-.225-.185l.177.073a2.292,2.292,0,0,0-.909-.322.123.123,0,0,1,.088-.024h.049l.049-.015c-.1-.024-.21,0-.3-.024a1.223,1.223,0,0,1-.3,0",
    transform: "translate(120.155 101.496)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M101.748,86.353c.088.693-.161,1.353-.572,1.441s-.821-.386-.918-1.095.185-1.344.6-1.441c.41-.113.8.4.894,1.095",
    transform: "translate(120.985 102.883)",
    fill: "#bad9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M100.258,86.7c.1.708.508,1.183.918,1.095s.66-.748.572-1.441a1.51,1.51,0,0,0-.258-.748l.024.088a.482.482,0,0,1-.177.483c-.137.024-.274-.137-.3-.371-.049-.225.04-.426.177-.45h.024a.407.407,0,0,0-.386-.1c-.41.1-.684.733-.6,1.441",
    transform: "translate(120.985 102.883)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M98.747,84.529a.944.944,0,0,0-.371-.064,1.521,1.521,0,0,1,.435.015.363.363,0,0,0,.225.024.768.768,0,0,0,.234-.024c-.049-.015-.508-.137-.523-.137a1.794,1.794,0,0,1,.426.049,1.215,1.215,0,0,0,.411.049,1.373,1.373,0,0,1-.338-.1,5.214,5.214,0,0,1,.523.049c-.064-.088-.185-.113-.274-.185.21-.015.572.234.684.258-.04-.049-.274-.258-.338-.258a1.159,1.159,0,0,1,.435.185c.015.024.015.024.04.024.1.049.185.137.274.185a1.415,1.415,0,0,0-.386-.346.435.435,0,0,0-.137-.088,1.609,1.609,0,0,1,.435.225,2.259,2.259,0,0,0-.21-.185c.121,0,.3.161.371.258a4.169,4.169,0,0,1,.313.362,2.193,2.193,0,0,0-.426-.636,1.485,1.485,0,0,1,.338.338l.225.322a.711.711,0,0,0,.073.113,1.8,1.8,0,0,0-.185-.435,2.123,2.123,0,0,0-.225-.322,1.138,1.138,0,0,1,.362.371c.137.225.185.362.274.523a1.894,1.894,0,0,0-.274-.66c.1.024.185.225.274.3a1.34,1.34,0,0,0-.088-.185c-.049-.073-.088-.113-.113-.161.161.073.362.572.45.708a3.212,3.212,0,0,0-.274-.757c.137.185.21.4.274.483a2.949,2.949,0,0,0-.088-.322,1.136,1.136,0,0,1-.113-.274,3.891,3.891,0,0,1,.386.982,2.492,2.492,0,0,0-.137-.611c.024.064.073.137.113.249.115.3.161.636.252.934a4.21,4.21,0,0,0-.066-.547,1.911,1.911,0,0,0-.185-.483l.137.161c.024.073.073.161.1.258.04.064.064.152.113.249.024.064.042.2.064.249a2.019,2.019,0,0,0-.113-.523c-.064-.185-.137-.3-.183-.435a2.942,2.942,0,0,1,.344.708,3.229,3.229,0,0,1,.088.684c0,.04-.022.137-.022.177a3.568,3.568,0,0,0-.227-.8,2.809,2.809,0,0,1,.09.684,3.672,3.672,0,0,0-.115-.547,1.538,1.538,0,0,1-.022.572,2.614,2.614,0,0,0-.042-.41,1.462,1.462,0,0,1-.024.459V85.97a.6.6,0,0,0-.071-.3,1.077,1.077,0,0,1-.018.362,2.746,2.746,0,0,0-.024-.45,1.554,1.554,0,0,0-.137-.435,4.6,4.6,0,0,1,.113.523,2.759,2.759,0,0,1,.024.435c-.024,0-.113-.547-.137-.644a1.242,1.242,0,0,0-.21-.5c.024.088.137.346.185.523a1.828,1.828,0,0,1,.088.62,2.073,2.073,0,0,0-.137-.572,1.825,1.825,0,0,1,.049.5,2.945,2.945,0,0,0-.073-.41,1.723,1.723,0,0,0-.113-.362,4.831,4.831,0,0,1,.137.821c-.024-.049-.088-.21-.113-.249a3.85,3.85,0,0,0-.386-.62,3.9,3.9,0,0,1,.386.781,1.5,1.5,0,0,0-.161-.3c-.04-.1-.137-.161-.177-.234l.289.483a3.348,3.348,0,0,0-.748-.684c.049.049.113.088.185.161a5.115,5.115,0,0,1,.474.547c-.049-.024-.088-.1-.137-.113a1.256,1.256,0,0,0-.338-.322l-.049-.024.161.161a1.651,1.651,0,0,1,.137.161,4.5,4.5,0,0,1-.435-.371l.049.121a.8.8,0,0,0-.41-.3c.015.024.04.024.064.04.049.049.161.185.185.185a4.139,4.139,0,0,0-.483-.3c.073.1.185.137.249.234-.152-.073-.289-.185-.45-.258.04.049.088.049.137.121-.1-.024-.161-.1-.249-.121l.088.1c-.088-.024-.161-.1-.234-.113h-.04l.113.088c-.088-.024-.185-.113-.274-.113l.024.024.064.04h.024a1.425,1.425,0,0,1-.322,0,.873.873,0,0,0-.289-.113c.015.024.04.024.064.049l.049.024c-.049,0-.137-.024-.21-.024a2.775,2.775,0,0,0-1.593.313,5.179,5.179,0,0,0-.757.6c-.137.113-.587.523-.708.62l.024-.049a.024.024,0,0,1,.024-.024l.137-.185c.073-.064.137-.152.21-.225l.338-.474a3.563,3.563,0,0,1,.66-.644,2.38,2.38,0,0,0,.258-.185l-.21.073a2.809,2.809,0,0,1,1.006-.362c-.024,0-.073-.024-.1-.024h-.088c.088-.024.225-.024.322-.049Z",
    transform: "translate(115.703 101.584)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M98.489,85.221c-.41-.024-.733.547-.708,1.256.049.708.41,1.28.821,1.3.41,0,.733-.563.708-1.271s-.386-1.28-.821-1.28",
    transform: "translate(118.013 102.856)",
    fill: "#bad9f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M98.6,87.773c-.41,0-.772-.587-.821-1.3-.024-.708.3-1.28.708-1.256a.585.585,0,0,1,.475.274l-.04-.024c-.137,0-.258.185-.234.41,0,.225.113.411.249.411s.258-.185.234-.411v-.049a1.717,1.717,0,0,1,.137.669c.024.708-.3,1.271-.708,1.271",
    transform: "translate(118.013 102.856)",
    fill: "#0053a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M100.319,91.815a2.681,2.681,0,0,1-1.053-.223,2.181,2.181,0,0,0,2.017-.049.542.542,0,0,0,.245-.516,17.151,17.151,0,0,0-1.059-3.569c-.106-.28-.21-.545-.307-.819l0,0,0,0c.1.271.2.536.309.819a17.283,17.283,0,0,1,1.062,3.569.561.561,0,0,1-.249.525,1.643,1.643,0,0,1-.969.265",
    transform: "translate(119.808 104.563)",
    fill: "#ed7d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M98.546,90.648c3.05.861,4.95.8,5.725-.185a32.055,32.055,0,0,1-5.725.185",
    transform: "translate(118.939 109.183)",
    fill: "#ec743d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M153.534,104.879H110.81a2.15,2.15,0,0,0-1.94,1.521l-7.6,28.966a1.134,1.134,0,0,0,1.119,1.529h42.746a2.144,2.144,0,0,0,1.94-1.529l7.6-28.966a1.152,1.152,0,0,0-1.143-1.521",
    transform: "translate(122.163 126.582)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M103.282,125.755l5.16-19.651a2.164,2.164,0,0,1,1.94-1.547H153.1c.845,0,2.35,1.1,2.1,1.942a1.114,1.114,0,0,0-1.183-1.234H111.293a2.155,2.155,0,0,0-1.942,1.523l-7.6,28.966a1.21,1.21,0,0,0,.3,1.231c-.708-.459-1.368-1.353-1.207-1.94Z",
    transform: "translate(121.682 126.193)",
    fill: "#f9e4e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M109.524,120.535H152.27a1.389,1.389,0,0,0,.452-.073c-.845,2.189-3.149,1.876-4.059,1.876H98c-2.737-.121-2.673-2.061-2.7-3.9h12.165a2.566,2.566,0,0,0,1.231,1.8,1.3,1.3,0,0,0,.821.3",
    transform: "translate(115.029 142.942)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M107.03,110.274c4.588,2.311,10.015,3.01,15.585,3.308-.064.21-.113.41-.161.62a3.664,3.664,0,0,0,3.694,4.332,4.835,4.835,0,0,0,4.639-3.995,2.684,2.684,0,0,0,.046-.708c5.8.161,11.383.483,16,2.286l-3.171,12.092H102.329Z",
    transform: "translate(123.504 133.093)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M115.316,110.875a3.381,3.381,0,0,0-3.22,2.761,2.315,2.315,0,0,0,2.35,2.779,3.334,3.334,0,0,0,3.2-2.779,2.292,2.292,0,0,0-2.326-2.761",
    transform: "translate(135.255 133.819)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M244.949,110.379a94.528,94.528,0,0,1,3.22,17.55c.249,4.129.6,7.464-1.6,10.249,0,0,5.458.611,7.327-1.167a6.063,6.063,0,0,1-.7,1.256s6.111.274,8.622-1.988c2.536-2.255-.113-51.547-17.066-47.416,0,0-16.954-1.691-15.61,17.984-.3,23.385-1.94,28.112-3.268,32.168,1.924,1.3,2.624.821,3.2-1.046.508-1.642.781-3.582.918-4.065a55.4,55.4,0,0,1-.87,6.005s6.841-.909,9.79-3.533c2.922-2.626,6.89-21.937,6.045-26",
    transform: "translate(272.61 106.953)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M183.323,103.7l22.113-.274,7.19,38.473-21.092,5.859Z",
    transform: "translate(221.258 124.834)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M184.242,104.448l7.534,40.228,17.775-4.952-6.641-35.51Z",
    transform: "translate(222.368 125.78)",
    fill: "#f1f8fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M186.186,139.466h5.136v-11.3l-3.244.885-1.891-10.125Z",
    transform: "translate(224.715 143.541)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M262.424,134.768H182.67c-.346,0-.62-.982-.62-2.214V131.46c0-1.216.274-2.189.62-2.189h79.754c.338,0,.611.973.611,2.189v1.095c0,1.231-.274,2.214-.611,2.214",
    transform: "translate(219.722 156.022)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M224.839,156.359s13.445,20.906,15.272,21.816c1.8.894,6.343,1.119,4.652,4.542-1.715,3.405-2.4,16.8-3.968,17.483-1.6.686-15.223,2.255-13.2,0,2.052-2.284,3.308-1.141,4.339-5.233s2.489-11.792.572-13.387c-1.94-1.6-13.765-15.908-13.765-15.908Z",
    transform: "translate(264.012 188.715)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M205.816,160.434s-16.367,26.929-19.4,29.343c-3.01,2.448-13.01,6.069-4.838,6.665,8.17.62,12.116-2.712,17.252-4.217,5.16-1.529,11.527-2.448,9.079-6.367-2.414-3.928-1.408-12.527,3.816-17.987s-5.908-7.437-5.908-7.437",
    transform: "translate(215.358 193.633)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M278.05,132.134s-40.46-1.07-56.5,12.092c-9.377,14.241-32.089,56.23-33.868,60.836,1.207,1.216,8.035,3.405,11.07,3.107,8.918-10.66,20.721-19.851,25.422-28.209,5.8-10.289,7.576-15.449,16.954-16.358,9.379-.894,30.577-3.928,36.92-3.928,6.367,0,0-27.54,0-27.54",
    transform: "translate(226.523 159.452)",
    fill: "#6d2d35",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M254.109,211.512h-2.116L236.77,148.028h4.676Z",
    transform: "translate(285.765 178.66)",
    fill: "#f09171",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M215.831,212.736h2.125l17.452-65.723h-4.652Z",
    transform: "translate(260.494 177.436)",
    fill: "#f09171",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M282.6,130.861l-23.524,4.065s-31.266.291-45.573,2.94c-13.008,2.447-14.9,17.21,0,37.538,8.486,11.569,15.652,20.794,30.3,31.171,3.719-2.737,5.16-3.758,6.182-10.362-1.07-1.432-3.807-10.538-4.652-12.317-8.1-16.954-18.92-23.12-19.081-24.786,1.805-2.937,48.109,15.409,57.327,4.613,8.784-10.289-.982-32.861-.982-32.861",
    transform: "translate(245.043 157.941)",
    fill: "#b5434c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M255.95,106.875a24.578,24.578,0,0,0-18.419,4.588c-5.153,5.25-11,13.919-10.626,28.224.45,18.17-2.809,19.328.587,24.329,14.193,5.859,38.5,31.058,32.773,4.041-4.129-19.562,9.082-34.141-1.578-55.844-.87-1.781-1.964-3.487-2.737-5.339",
    transform: "translate(272.679 128.667)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M226.881,144.034c-.258,9.468-1.6,12.253-.572,15.239,5.771.572,16.382,2.9,19.03,6.6,3.012,4.244,6.047,4.855,4.63,1.73s-5.129-7.574.62-22.822,8.468-25.534,2.809-36.121Z",
    transform: "translate(272.678 131.147)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M249.6,117.223a73.612,73.612,0,0,1-4.767-19.191L234.864,101s5.659,12.7.225,17.252a46.378,46.378,0,0,0-3.9,3.558,24.578,24.578,0,0,1,18.419-4.588",
    transform: "translate(279.025 118.318)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M243.116,100.156c-.563-.532-1.32-1.192-2.092-1.876l-8.148,2.4-.024.04a33.214,33.214,0,0,1,2.553,9.951c2.423-1.457,5.087-3.88,8.121-8.051-.152-.942-.289-1.779-.41-2.463",
    transform: "translate(281.037 118.617)",
    fill: "#ed7d5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M269.539,108.162c-10.289,3.606-9.152,14.451-18.62,30.447-4.91,8.258-9.452,8.146-9.452,8.146a219.1,219.1,0,0,1-25.4-1.618c-8.7-1.055-9.267,1.529-3.189,3.694,12.2,4.357,24.868,9.057,35.092,7.938,10.2-1.134,27.684-27.218,28.6-34,1.232-9.379-1.852-16.406-7.029-14.612",
    transform: "translate(252.061 130.205)",
    fill: "#f19651",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M253.579,186.321c-.636,0-1.3-.024-1.955-.04a97.687,97.687,0,0,1-18.646-2.286c-5.409-1.095-8.4-1.715-11.913-.024a2.343,2.343,0,0,1-3.149-1.119,2.371,2.371,0,0,1,1.121-3.171c4.95-2.368,9.128-1.529,14.9-.338a95.117,95.117,0,0,0,17.8,2.189c8.943.225,14.418-1.119,17.2-4.22,2.512-2.761,3.244-7.373,2.326-14.515-.322-2.423-.636-4.427-.909-6.206-.757-4.974-1.28-8.261-.644-13.356.572-4.716,2.15-11.019,5.78-23.248a2.376,2.376,0,0,1,4.557,1.344c-6.8,22.886-6.433,25.126-4.992,34.527.274,1.8.587,3.855.909,6.321,1.119,8.629,0,14.442-3.494,18.322-3.6,3.992-9.468,5.82-18.894,5.82",
    transform: "translate(262.724 142.758)",
    fill: "#f09171",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M206.908,170.724c-10.843,5.288-16.68,8.349-20.149,8.051-.821-.066-1.505-.161-2.077-.249-3.882,2.286-10.039,5-3.107,5.5,8.17.62,12.114-2.712,17.252-4.217,5.16-1.529,11.527-2.448,9.079-6.369a8.6,8.6,0,0,1-1-2.712",
    transform: "translate(215.36 206.053)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M236.564,166.441c-.274,8.583-1.457,17.091-6.707,18.708a8.943,8.943,0,0,1-3.792.346c-.821,1.006-1.827,1.031-3.2,2.536-2.028,2.255,11.593.684,13.2,0,1.569-.684,2.253-14.08,3.968-17.486,1.393-2.8-1.417-3.469-3.469-4.1",
    transform: "translate(268.742 200.883)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M229.068,126.909c-6.963-.088-13.855-4.242-17.3-3.622-3.421.587-12.824,7.96-11.408,8.283,1.408.3,9.146-3.308,9.443-3.381s1.578,2.584,6.318,3.792c4.727,1.183.024-3.558,14.725.861,9.556,2.9-1.779-5.932-1.779-5.932",
    transform: "translate(241.647 148.724)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M251.955,103l1.031,8.236s-9.018.523-13.509,3.059C235,116.8,228.383,124.1,228.383,124.1l5.411-9.313.772-5.956Z",
    transform: "translate(275.643 124.309)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M266.034,107.657c-6.7-1.256-9.79,4.743-14.118,14.53s-11.754,21.681-13.246,23.21c-1.457,1.529-24.824,0-24.824,0s-.684,6.753,0,7.55c.708.821,4.747.708,4.747.708s1.618,1.3,3.125,2.326c1.527,1.006,14.336,2.924,20.286,2.626s11.414-.8,12.213-1.708c.819-.918,17.066-25.945,18.07-34.914,1.006-8.993-2.849-13.694-6.254-14.33",
    transform: "translate(257.731 129.736)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 21.043,
    height: 2.286,
    transform: "translate(410.9 283.006)",
    fill: "#e26971"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M249.892,98.6c4.266,14.232-11.827,30.1-19.553,15.859-1.119-2.052-2.834-4.2-3.769-7.44-1.94-6.89.733-13.668,5.974-15.157s15.385-.137,17.349,6.738",
    transform: "translate(272.69 110.221)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M234.283,91.411c-12.663.6-10.675,19.651-10.675,19.651s3.284,1,10.176-.135c-.523-2.039-.3-7.261-.3-7.261a47.829,47.829,0,0,0,1.8,6.8c1.457.682,3.1.088,5.908-.6,1.441,6.047,5.5,8.607,8.285,9.492,3.083.958,6.318,2.1,9.973.3,3.633-1.83,1.62-20.377-.3-24.12-2.9-5.61-7.711-10.635-16.042-7.963a60.983,60.983,0,0,0-8.832,3.831",
    transform: "translate(269.743 104.812)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M244.467,112.438a18.967,18.967,0,0,1-2.673-.2c-4.4-.66-10.337-3.171-10.8-17.276a.405.405,0,0,1,.4-.435.411.411,0,0,1,.426.41c.185,5.82,1.353,10.159,3.454,12.825a9.729,9.729,0,0,0,6.634,3.655c4.129.611,6.85-.161,8.13-2.286a.429.429,0,0,1,.565-.137.425.425,0,0,1,.137.572c-1.137,1.916-3.238,2.873-6.272,2.873",
    transform: "translate(278.799 114.088)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 18.933,
    height: 2.286,
    transform: "translate(438.836 283.006)",
    fill: "#e26971"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 2.447,
    height: 0.87,
    transform: "translate(454.622 282.137)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 2.439,
    height: 0.982,
    transform: "translate(450.863 282.024)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 2.439,
    height: 1.207,
    transform: "translate(447.096 281.799)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 2.463,
    height: 1.368,
    transform: "translate(443.329 281.638)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 2.472,
    height: 1.578,
    transform: "translate(439.559 281.428)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M226.123,98.982c-1.231-1.505,4.354-1.006,5.747-.6a41.068,41.068,0,0,0-4.379.483c-1.457.362-1.046.523-1.368.113",
    transform: "translate(272.703 118.238)",
    fill: "#683e41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M226.793,99.544c0,.41-.024,4.813.2,4.974.644.4,3.469-.386,3.558-.8.459-2-1.545-3.284-2.986-4.178-.322-.177-.772-.289-.772,0",
    transform: "translate(273.724 119.929)",
    fill: "#f4ae7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M229.209,104.845c3.679-1.569,3.2-3.01,3.171-2.986-.885.958-3.783,2.214-3.533,2.712.049.113.274.322.362.274",
    transform: "translate(276.185 122.937)",
    fill: "#f09171",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M128.257,141.637c-5.546,5.063-3.132,10.128.958,19.553,4.1,9.4,4.838,44.181,4.838,44.181l-3.381-.483s.483-35.735-4.1-45.388c-4.588-9.675-6.528-14.491-10.611-11.359-4.1,3.149,12.3-6.5,12.3-6.5",
    transform: "translate(139.155 170.947)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M147.9,147.225c-.684-3.01-4.677-6.248-10.046-9.009.8,4.427,3.357,11.681.708,13.162-3.56,2.013-.34-8.122-1.708-13.67a66.564,66.564,0,0,0-16.662-5.473c0,.024.024.049.024.073,3.129,7.96,7.237,11.11,5.546,12.317-1.256.918-5.409-8.309-10.885-13.025-4.081-.21-7.576.338-9.629,1.98-3.171,2.512-5.3,4.725-2.1,12.39a14.307,14.307,0,0,0,6.941,2.511c7.228.733,10.609.958,5.537,3.381-2.487,1.183-6.634-.073-10.013-.821,1.095,2,2.439,4.29,4.081,6.892a25.951,25.951,0,0,0,3.381,4.315,10.83,10.83,0,0,0,5.449,0c3.381-1.441,12.076-6.029,14.241-4.114,2.125,1.9-16.084,3.107-14.828,7.9,8.832,5.087,18.942,2.673,20.721-2,2.417-6.279,11.271-7.762,9.243-16.8",
    transform: "translate(122.576 158.781)",
    fill: "#fff0f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M114.282,155.9c9.653-7.237,19.553-.483,24.625,7.254,5.065,7.711,1.435,25.1,1.435,25.1s-1.918,0-1.918-.733c0-.7,5.3-20.511-7.252-29.432-7.857-5.595-13.517-2.9-14.241-.249s3.147,7.479,3.147,7.479Z",
    transform: "translate(137.931 184.434)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M130.382,147.466c-9.653,0-12.8,14.974-10.134,23.667,2.648,8.7,6.279,24.877,6.279,24.877l2.414-2.423s-9.194-22.7-7-32.837c2.172-10.128,7.486-11.842,8.444-11.842s0-1.441,0-1.441",
    transform: "translate(144.035 177.982)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M122.06,159.4a6.875,6.875,0,0,0-2.536-2.15,19.192,19.192,0,0,0,.5,2.077c1.216,3.946,2.609,9.468,3.792,14.305.113-.611.274-1.569.523-3.059a7.3,7.3,0,0,0,.137-1.11A97.41,97.41,0,0,1,122.06,159.4",
    transform: "translate(144.258 189.789)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M138.828,165.694c-18.346-7.735-8.671-18.322-24.852-11.319a11.886,11.886,0,0,0-3.928,3.447,11.966,11.966,0,0,0,5.138.408c4.838-.73,3.147,3.125-4.84,4.107a18.766,18.766,0,0,0-3.719.781c-3.807,7.3-5.522,16.881,2.511,20.213a18.033,18.033,0,0,0,5.731,1.192c2.487-1.988-.618-13.378,3.213-11.8,3.679,1.507-1.159,9.766-.5,11.842a53.9,53.9,0,0,0,11.478-1.593,5.658,5.658,0,0,0,3.012-3.494c1.207-5.063-6.755-8.212-6.989-12.551-.225-3.992,2.922,8.784,11.231,10.659,7.534-3.518,11.094-8.285,2.512-11.891",
    transform: "translate(124.841 183.557)",
    fill: "#fff0f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M129.818,161.629c-1.916-4.081,3.147-5.063,2.9-1.916-.2,2.785-.225,9.538,2.624,11.383A45.083,45.083,0,0,0,152,165.557a2.07,2.07,0,0,0-.2-1.256c-2.165-4.363-16.181-7.969-11.816-9.426,3.445-1.143,9.514,5.659,14.394,9.079,2.946-2.214,4.91-4.877,4.91-7.824,0-4.019-4.888-8.559-11.183-10.724-2.834.274-5.482,1.819-9.587,4.153-6.071,3.445-4.679-2.125,1.07-5.433a17.384,17.384,0,0,0-13.548,7.462s.338,2.143-1.942,5.5c-6.254,9.152.96,14.466,9.58,14.127-.5-2.4-2.512-6.738-3.855-9.587",
    transform: "translate(146.925 173.953)",
    fill: "#fff0f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M126.392,154.068c-4.725,3.63-9.975,7.9-16.406,10.8s-5.16,12.348-5.16,12.348-.958-8.146,4.4-10.955c5.361-2.785,8.927-6.12,12.986-6.755a58.5,58.5,0,0,0,6.343-1.28s-1.3-2.576-.547-3.533c.757-.982-1.618-.62-1.618-.62",
    transform: "translate(126.393 185.871)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M103.992,134.615c17.276,4.612,29.948,15.674,32.314,18.346,2.35,2.7,2.35,3.445,2.35,3.445l-1.819,3.423-.845-.435s1.393-2.9-2.262-6.634c-6.3-6.48-13.968-11.593-19.216-13.855s-10.523-4.29-10.523-4.29",
    transform: "translate(125.511 162.471)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M133.869,190.893h-6.594a8.513,8.513,0,0,1-8.517-8.51V167.226h23.621v15.157a8.507,8.507,0,0,1-8.51,8.51",
    transform: "translate(143.333 201.831)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 23.619,
    height: 1.642,
    transform: "translate(262.091 371.778)",
    fill: "#fff0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 23.619,
    height: 0.982,
    transform: "translate(262.091 374.788)",
    fill: "#fff0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M21.406,154.966a26.673,26.673,0,0,1-.185,2.8,26.673,26.673,0,0,0,.185-2.8",
    transform: "translate(25.612 187.034)",
    fill: "#f5f6f3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M41.411,121.8a12.287,12.287,0,0,1,3.211-2.688.716.716,0,0,1,.942.274c.909,1.691,1.755,3.421,2.779,5.038A6.569,6.569,0,0,0,49.623,126c.024,0,.137.073.185.088l.022-.015a1.442,1.442,0,0,0,.179-.41c.821-2.511-.179-5.184.483-7.7a8.292,8.292,0,0,1,2.116-3.672c1.055-1.055,2.447-1.554,3.083-2.971a.616.616,0,0,1,.483-.338h.113a.9.9,0,0,1,.611.338c1.49,2.174,3.582,4.405,3.992,7.1.371,2.4-.934,4.379-2.326,6.206a22.587,22.587,0,0,0-1.843,2.761c-.274.523-.781,1.505-.249,2.028.547.547,1.368-.435,1.794-.861a32.448,32.448,0,0,0,2.4-2.971c1.256-1.666,3.262-4.2,5.637-3.743a2.226,2.226,0,0,1,1.529,2.238,8.142,8.142,0,0,1-1.393,4.379c-1.666,2.858-5.065,3.679-7.23,5.983-.508.523-1.9,2.326-1.095,3.083.274.249.909.177,1.231.113a5,5,0,0,0,2.326-.918c2.465-1.891,3.357-5.177,5.934-6.981a5.678,5.678,0,0,1,4.217-.958,2.444,2.444,0,0,1,1.739,2.463,7.046,7.046,0,0,1-1.216,3.794,8.788,8.788,0,0,1-3.123,3.1c-2.6,1.457-5.886,1.642-7.625,4.379a1.816,1.816,0,0,0-.362,1.3c.088.362.6.459.87.523a6.806,6.806,0,0,0,4.268-.821,14.734,14.734,0,0,0,3.509-3.235,9.326,9.326,0,0,1,4.041-2.673,2.936,2.936,0,0,1,3.357.772,4.37,4.37,0,0,1,.274,3.469,10.134,10.134,0,0,1-2.174,3.97,9.6,9.6,0,0,1-4.242,2.445c-1.569.523-3.2.845-4.74,1.435a4.012,4.012,0,0,1-1.167.274,11.079,11.079,0,0,0-1.441.137c-.386.113-.113.523,0,.8.322.708,1.351.669,2.013.733.611.049,1.207.21,1.827.21a12.689,12.689,0,0,0,2.092-.252,9.641,9.641,0,0,1,4.2-.022,3.734,3.734,0,0,1,2.463,2.962c.508,2.785-2.624,4.5-4.926,4.838a6.239,6.239,0,0,1-4.129-.821c-1.6-.909-2.876-2.238-4.727-2.463a1.921,1.921,0,0,0,.8,1.891,10.807,10.807,0,0,0,3.268,1.6c2.141.8,5.312,1.505,6.455,3.743a.692.692,0,0,1-.113.821,6,6,0,0,1-3.63,1.869,5.488,5.488,0,0,1-3.332-1.1c-1.732-1.165-3.22-2.944-5.162-3.743a4.616,4.616,0,0,0,1.258,1.256,4.8,4.8,0,0,1,1.737,2.964c.41,1.788-.207,3.728-2.3,3.728a6.678,6.678,0,0,1-3.244-1.143,8.237,8.237,0,0,1-2.648-2.673,12.079,12.079,0,0,1-1.554-4.405c-1.755,3.4-5.564,6.965-9.146,4.017-3.059-2.511,1.982-4.451,3.992-6.431a10.742,10.742,0,0,0-1.143.547,33.7,33.7,0,0,1-3.147,1.569c-2.013.821-4.29.757-5.5-1.344-1.055-1.779,1.119-2.624,2.463-3.01,1.07-.346,3.1-.684,3.9-1.779-2.7.3-5.659.611-7.969-.918a5.476,5.476,0,0,1-2.439-3.374c-.088-1.07,1.07-1.463,1.916-1.527,2.286-.227,4.5.772,6.777.706a10.44,10.44,0,0,0,1.642-.207,2.422,2.422,0,0,0,.6-.179.621.621,0,0,0,.179-.137.334.334,0,0,0-.042-.119,3.788,3.788,0,0,0-.733-.572,4.187,4.187,0,0,0-1.891-.684c-1.344-.137-2.673.022-3.992-.2a6.414,6.414,0,0,1-3.694-2.238,6.786,6.786,0,0,1-1.852-3.582A2.673,2.673,0,0,1,36,138.641c3.469-1.32,5.5,2.262,7.985,3.88a8.393,8.393,0,0,0,2.191.958c.3.1,1.19.4,1.481.161.183-.137-.41-1.095-.525-1.28a5.231,5.231,0,0,0-1.94-1.819c-2.077-1.192-4.6-1.554-6.23-3.421-1.07-1.24-1.916-3.332-.861-4.822,1.095-1.6,3.582-1.161,4.974-.252,1.755,1.17,2.639,3.544,4.765,4.092a3.512,3.512,0,0,0-.885-2.812,32.838,32.838,0,0,0-3.43-3.516,11.086,11.086,0,0,1-2.873-3.736,4.278,4.278,0,0,1,.757-4.275",
    transform: "translate(41.093 133.955)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M13.809,148.709a11.545,11.545,0,0,1-.113-4.178.677.677,0,0,1,.772-.572c1.891.338,3.792.757,5.707.934a6.373,6.373,0,0,0,2.006-.024,2.131,2.131,0,0,0,.21-.088c0-.024,0-.024-.024-.049a1.2,1.2,0,0,0-.21-.386c-1.457-2.189-4.153-3.059-5.725-5.111a8.5,8.5,0,0,1-1.578-3.97c-.177-1.457.3-2.873-.435-4.242-.249-.523.3-.982.757-.934,2.624.152,5.683-.121,8.035,1.232,2.116,1.207,2.873,3.46,3.445,5.659a23.482,23.482,0,0,0,1.022,3.171c.249.547.708,1.547,1.441,1.459.772-.088.523-1.344.435-1.964a33.261,33.261,0,0,0-.845-3.7c-.523-2.028-1.28-5.16.547-6.753a2.2,2.2,0,0,1,2.688.185,8.3,8.3,0,0,1,2.584,3.783c1.209,3.083-.232,6.257.225,9.4.09.733.662,2.922,1.732,2.761.393-.049.708-.611.87-.885a5.009,5.009,0,0,0,.733-2.4c.024-3.107-2.013-5.846-1.827-8.993a5.7,5.7,0,0,1,1.874-3.9,2.45,2.45,0,0,1,2.988.161,7.024,7.024,0,0,1,2.238,3.284,8.788,8.788,0,0,1,.5,4.387c-.459,2.94-2.35,5.661-1.28,8.7a1.806,1.806,0,0,0,.806,1.095c.338.152.724-.161.958-.371a6.819,6.819,0,0,0,1.98-3.831,14.8,14.8,0,0,0-.362-4.791,9.415,9.415,0,0,1,.386-4.813,2.916,2.916,0,0,1,2.7-2.15,4.3,4.3,0,0,1,2.9,1.94,10.171,10.171,0,0,1,1.781,4.153,9.6,9.6,0,0,1-.708,4.84c-.572,1.554-1.329,3.035-1.827,4.612a3.312,3.312,0,0,1-.483,1.095,7.86,7.86,0,0,0-.775,1.207c-.183.362.322.435.62.5.75.161,1.368-.66,1.8-1.134.41-.435.911-.83,1.3-1.3a14.989,14.989,0,0,0,1.119-1.8,9.545,9.545,0,0,1,2.56-3.308,3.762,3.762,0,0,1,3.856-.113c2.5,1.344,1.916,4.838.748,6.866a6.155,6.155,0,0,1-3.22,2.737c-1.682.708-3.509.894-4.838,2.191a1.885,1.885,0,0,0,1.988.547,10.429,10.429,0,0,0,3.26-1.571c1.964-1.207,4.476-3.244,6.941-2.761a.725.725,0,0,1,.594.587,6.032,6.032,0,0,1-.8,4.019,5.445,5.445,0,0,1-2.922,1.94c-1.964.644-4.29.708-6.142,1.739a4.213,4.213,0,0,0,1.779-.234,5.117,5.117,0,0,1,3.405.483c1.666.8,2.785,2.463,1.505,4.129a6.67,6.67,0,0,1-2.9,1.827,8.462,8.462,0,0,1-3.743.435,12.108,12.108,0,0,1-4.427-1.505c1.593,3.485,2.028,8.669-2.489,9.669-3.88.845-2.278-4.308-2.6-7.093a10.082,10.082,0,0,0-.274,1.231c-.225,1.143-.386,2.3-.708,3.423-.611,2.1-2.077,3.831-4.476,3.494-2.052-.3-1.368-2.511-.836-3.792.41-1.073,1.384-2.876,1.022-4.171-1.432,2.278-3.01,4.838-5.659,5.676a5.459,5.459,0,0,1-4.156-.155c-.909-.6-.474-1.761-.024-2.47,1.234-1.918,3.405-3.037,4.752-4.88a9.252,9.252,0,0,0,.87-1.417,4,4,0,0,0,.225-.572v-.249h-.113a2.89,2.89,0,0,0-.911.21,4.223,4.223,0,0,0-1.715,1.07c-.934.958-1.618,2.1-2.624,2.986a6.353,6.353,0,0,1-4.041,1.529,6.921,6.921,0,0,1-3.968-.772,2.677,2.677,0,0,1-1.006-3.268c1.119-3.533,5.208-2.922,8.009-3.855a9.583,9.583,0,0,0,2.1-1.119c.249-.177,1.048-.708,1.048-1.095,0-.2-1.119-.338-1.322-.362a5.091,5.091,0,0,0-2.648.41c-2.214.885-4.081,2.648-6.544,2.761-1.644.088-3.794-.547-4.339-2.3-.55-1.852,1.32-3.542,2.922-4.067,1.98-.66,4.4.115,6.133-1.207a3.586,3.586,0,0,0-2.761-1.055,31.812,31.812,0,0,0-4.855.532,11.4,11.4,0,0,1-4.725-.073,4.243,4.243,0,0,1-2.9-3.235",
    transform: "translate(16.369 155.34)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M67.417,121.587a12.072,12.072,0,0,1,4.1-.636.688.688,0,0,1,.684.684c-.088,1.94-.274,3.855-.2,5.771a6.61,6.61,0,0,0,.274,2.013,1.51,1.51,0,0,1,.113.161h.042a2.1,2.1,0,0,0,.369-.256c1.964-1.732,2.514-4.518,4.332-6.345a8.337,8.337,0,0,1,3.743-2.052c1.441-.386,2.873-.088,4.153-.958a.694.694,0,0,1,1.031.62c.177,2.624.821,5.61-.21,8.122-.934,2.238-3.074,3.286-5.2,4.131a19.485,19.485,0,0,0-2.986,1.417c-.532.313-1.465.885-1.28,1.618.185.748,1.393.338,2,.185a33.29,33.29,0,0,0,3.566-1.329c1.931-.772,4.95-1.916,6.753-.3a2.166,2.166,0,0,1,.154,2.7,8.012,8.012,0,0,1-3.423,3.035c-2.9,1.593-6.23.572-9.28,1.417-.708.177-2.834,1.046-2.538,2.077.115.362.708.611,1.006.748a5.348,5.348,0,0,0,2.465.41c3.074-.362,5.546-2.737,8.669-2.946a5.84,5.84,0,0,1,4.131,1.368,2.431,2.431,0,0,1,.2,2.995,6.948,6.948,0,0,1-2.988,2.626,8.587,8.587,0,0,1-4.266,1.046c-2.986-.064-5.908-1.618-8.784-.161a1.829,1.829,0,0,0-1.006.918c-.088.362.276.708.5.909a6.86,6.86,0,0,0,4.065,1.481,15.133,15.133,0,0,0,4.7-.958,9.231,9.231,0,0,1,4.838-.225,2.934,2.934,0,0,1,2.465,2.4,4.379,4.379,0,0,1-1.554,3.1,9.945,9.945,0,0,1-3.906,2.3,9.567,9.567,0,0,1-4.9-.09c-1.593-.362-3.147-.909-4.791-1.207a3.959,3.959,0,0,1-1.141-.362,9.252,9.252,0,0,0-1.3-.62c-.388-.113-.388.386-.413.684-.088.757.823,1.28,1.353,1.642.5.364.936.8,1.459,1.119a14.955,14.955,0,0,0,1.916.894,9.58,9.58,0,0,1,3.606,2.119,3.752,3.752,0,0,1,.62,3.816c-1.031,2.639-4.564,2.5-6.738,1.618a6.347,6.347,0,0,1-3.125-2.858c-.894-1.593-1.3-3.372-2.785-4.518a1.96,1.96,0,0,0-.3,2.037,11.366,11.366,0,0,0,1.988,3.037c1.441,1.794,3.792,4.032,3.63,6.544a.7.7,0,0,1-.53.636,5.936,5.936,0,0,1-4.083-.274,5.376,5.376,0,0,1-2.278-2.639c-.894-1.876-1.256-4.178-2.511-5.868a4.167,4.167,0,0,0,.459,1.715,5.169,5.169,0,0,1-.049,3.445c-.572,1.755-2.1,3.074-3.9,2A6.533,6.533,0,0,1,58.15,169.9a8.377,8.377,0,0,1-.892-3.646,11.773,11.773,0,0,1,.916-4.566c-3.244,2.006-8.331,3.1-9.9-1.256-1.329-3.743,3.992-2.809,6.729-3.469-.435-.064-.845-.088-1.256-.113-1.167-.088-2.35-.088-3.494-.274-2.165-.346-4.081-1.578-4.041-3.992.024-2.077,2.311-1.666,3.655-1.329,1.119.274,3.035,1.006,4.266.483-2.439-1.119-5.175-2.375-6.343-4.886a5.331,5.331,0,0,1-.362-4.131c.474-.982,1.666-.708,2.414-.338,2.077.982,3.469,2.986,5.475,4.107a11.883,11.883,0,0,0,1.487.66,3,3,0,0,0,.614.161c.071,0,.183-.024.232-.024a.348.348,0,0,0,0-.137,3.24,3.24,0,0,0-.322-.87,3.841,3.841,0,0,0-1.28-1.547c-1.07-.821-2.278-1.353-3.308-2.238a6.415,6.415,0,0,1-2-3.807,6.7,6.7,0,0,1,.249-4.017,2.643,2.643,0,0,1,3.1-1.417c3.679.636,3.566,4.765,4.864,7.437a8.245,8.245,0,0,0,1.368,1.94c.234.225.821.958,1.216.909.225-.04.2-1.159.2-1.368A5.331,5.331,0,0,0,61,139.6c-1.159-2.077-3.147-3.694-3.582-6.142-.3-1.618.071-3.831,1.739-4.582,1.755-.781,3.67.863,4.4,2.368.885,1.9.45,4.387,1.98,5.957a3.581,3.581,0,0,0,.684-2.873,33.631,33.631,0,0,0-1.134-4.767,10.914,10.914,0,0,1-.523-4.676,4.237,4.237,0,0,1,2.849-3.293",
    transform: "translate(55.774 144.666)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5543",
    "data-name": "Path 5543",
    d: "M25.656,138.436a11.573,11.573,0,0,1,1.432-3.922.689.689,0,0,1,.934-.249c1.651,1.024,3.244,2.1,4.959,2.988a6.832,6.832,0,0,0,1.869.708.769.769,0,0,0,.225-.024v-.024a2.994,2.994,0,0,0-.04-.45c-.55-2.56-2.739-4.387-3.447-6.877a8.417,8.417,0,0,1,0-4.266c.364-1.408,1.322-2.551,1.161-4.1-.042-.572.62-.772,1.053-.6,2.368,1.119,5.314,1.988,7,4.129,1.505,1.9,1.393,4.275,1.119,6.552a23.847,23.847,0,0,0-.234,3.286c.024.62.1,1.715.806,1.916.748.21.982-1.07,1.119-1.666a31.345,31.345,0,0,0,.587-3.761c.249-2.077.708-5.272,3.012-6.069a2.236,2.236,0,0,1,2.447,1.159,8.281,8.281,0,0,1,.982,4.476c0,3.31-2.536,5.725-3.268,8.832-.161.708-.452,2.962.618,3.2.364.088.87-.3,1.119-.508A5.055,5.055,0,0,0,50.66,141.2c1.192-2.873.3-6.157,1.627-9.009a5.654,5.654,0,0,1,3.2-2.946,2.431,2.431,0,0,1,2.712,1.256,6.983,6.983,0,0,1,.87,3.88,8.611,8.611,0,0,1-1.167,4.244c-1.505,2.576-4.242,4.4-4.379,7.623a1.721,1.721,0,0,0,.338,1.32c.249.258.733.1,1.031,0a6.9,6.9,0,0,0,3.26-2.825,15.186,15.186,0,0,0,1.417-4.588,9.386,9.386,0,0,1,2.143-4.332A2.938,2.938,0,0,1,65,134.812a4.267,4.267,0,0,1,1.982,2.851,10.173,10.173,0,0,1,.113,4.54,9.381,9.381,0,0,1-2.439,4.226c-1.095,1.256-2.353,2.326-3.374,3.624a3.761,3.761,0,0,1-.87.845,7.209,7.209,0,0,0-1.192.821c-.274.3.161.523.41.684.62.459,1.514-.088,2.079-.362a18.082,18.082,0,0,0,1.691-.757,10.909,10.909,0,0,0,1.715-1.256,9.382,9.382,0,0,1,3.606-2.119,3.7,3.7,0,0,1,3.622,1.322c1.827,2.147-.015,5.184-1.843,6.665a6.283,6.283,0,0,1-3.992,1.344c-1.83.024-3.584-.474-5.3.249a1.845,1.845,0,0,0,1.644,1.231,11.084,11.084,0,0,0,3.606-.249c2.262-.386,5.361-1.368,7.486,0a.694.694,0,0,1,.3.781,6.029,6.029,0,0,1-2.214,3.421,5.452,5.452,0,0,1-3.43.708c-2.068-.113-4.242-.918-6.343-.644a4.259,4.259,0,0,0,1.737.459,5.015,5.015,0,0,1,2.988,1.69c1.256,1.346,1.666,3.335-.137,4.381a6.311,6.311,0,0,1-3.374.636,8.547,8.547,0,0,1-3.63-.973,12.154,12.154,0,0,1-3.558-3.019c.2,3.816-1.3,8.815-5.893,8.058-3.9-.636-.5-4.838.234-7.552a7.145,7.145,0,0,0-.708,1.024c-.638.982-1.234,2.013-1.942,2.946-1.344,1.715-3.332,2.785-5.433,1.593-1.8-1.022-.338-2.825.6-3.855.772-.821,2.35-2.143,2.487-3.487-2.165,1.6-4.564,3.374-7.349,3.2a5.375,5.375,0,0,1-3.785-1.693c-.618-.87.179-1.779.863-2.284,1.876-1.346,4.29-1.571,6.23-2.8a7.984,7.984,0,0,0,1.329-.982,3.889,3.889,0,0,0,.435-.459c.04-.064.064-.161.088-.2a.714.714,0,0,0-.113-.073,4.551,4.551,0,0,0-.918-.137,3.975,3.975,0,0,0-1.98.362c-1.231.547-2.286,1.353-3.558,1.827a6.439,6.439,0,0,1-4.292-.088,6.849,6.849,0,0,1-3.43-2.165,2.672,2.672,0,0,1,.274-3.405c2.353-2.9,5.919-.821,8.856-.636a9.453,9.453,0,0,0,2.375-.274c.3-.1,1.231-.274,1.368-.62.088-.2-.885-.724-1.095-.845a5.1,5.1,0,0,0-2.6-.587c-2.4,0-4.774.958-7.117.152-1.529-.523-3.317-1.916-3.156-3.736.161-1.916,2.511-2.809,4.2-2.7,2.1.113,4.043,1.715,6.16,1.143a3.544,3.544,0,0,0-2.189-2.013,33.979,33.979,0,0,0-4.725-1.3,11.333,11.333,0,0,1-4.356-1.8,4.3,4.3,0,0,1-1.481-4.089",
    transform: "translate(30.904 146.711)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5544",
    "data-name": "Path 5544",
    d: "M30.95,123.463c.8,3.445,1.49,6.932,2.489,10.337a35.478,35.478,0,0,0,4.451,9.763c4.129,6.3,9.379,11.754,13.621,17.938a.621.621,0,0,1,0,.708,18.179,18.179,0,0,1,1.627,4.974,59.321,59.321,0,0,1,.907,8.92q.205,5.446-.073,10.882c-.174,4.293-.474,8.559-.289,12.849.018.249.018.508.04.733.049.894-1.318.894-1.366,0a114.078,114.078,0,0,1,.207-12.527c.177-3.719.249-7.437.137-11.158a62.481,62.481,0,0,0-.757-8.6c-.433-2.6-1.159-5.522-3.1-7.415a.641.641,0,0,1-.1-.845c-3.944-5.385-8.508-10.335-12.178-15.954a37.565,37.565,0,0,1-4.405-9.669c-1.031-3.469-1.715-7.038-2.536-10.571-.21-.87,1.119-1.231,1.32-.362",
    transform: "translate(35.735 148.41)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5545",
    "data-name": "Path 5545",
    d: "M40.387,178.55c.724-6.665,3.807-12.648,7-18.468,3.147-5.747,6.48-11.593,7.437-18.209.137-.861,1.457-.5,1.32.371-1.916,13.162-12.913,23.023-14.394,36.306-.1.885-1.481.885-1.368,0",
    transform: "translate(48.736 170.638)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5546",
    "data-name": "Path 5546",
    d: "M31.788,157.03c5.893,2.584,11.666,6.5,15.61,11.617a24.164,24.164,0,0,1,4.2,9.289,99.584,99.584,0,0,1,1.593-10.313,238.078,238.078,0,0,0,3.5-24.053q.444-4.83.682-9.653c.026-.87,1.417-.87,1.37,0a242.487,242.487,0,0,1-2.834,26.655c-.936,5.974-2.5,11.891-2.988,17.911a66.872,66.872,0,0,1,2.3-9.629,57.226,57.226,0,0,1,5.868-12.847.778.778,0,0,1,.185-.508,4.829,4.829,0,0,1,.523-.563c.611-.942,1.256-1.852,1.94-2.745a.588.588,0,0,1,.982.071,22.735,22.735,0,0,1,3.4-2.147c2.809-1.459,6.321-2.417,7.689-5.612.346-.821,1.529-.113,1.192.684-1.353,3.2-4.637,4.379-7.512,5.773a22.538,22.538,0,0,0-6.68,4.91,56,56,0,0,0-6.327,13.573,60.382,60.382,0,0,0-2.9,17.872v.088a.654.654,0,0,1-.636.781.7.7,0,0,1-1.344-.258c-.508-6.48-1.256-13.3-5.409-18.62-3.856-4.88-9.428-8.6-15.087-11.085-.8-.346-.113-1.529.684-1.192",
    transform: "translate(37.112 160.841)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5547",
    "data-name": "Path 5547",
    d: "M59.777,125.025a11.532,11.532,0,0,1,4.041-1.055.7.7,0,0,1,.733.644c.088,1.916.113,3.855.338,5.771a6.63,6.63,0,0,0,.483,1.942,1.073,1.073,0,0,0,.137.177.015.015,0,0,1,.015-.015,1.113,1.113,0,0,0,.346-.3c1.8-1.894,2.052-4.727,3.721-6.731a8.646,8.646,0,0,1,3.518-2.4c1.384-.523,2.849-.362,4.056-1.368.435-.362,1.006.064,1.07.523.435,2.6,1.368,5.5.572,8.124-.708,2.3-2.737,3.558-4.765,4.612a19.261,19.261,0,0,0-2.858,1.691c-.474.362-1.344,1.022-1.095,1.73.258.733,1.417.21,1.988-.024a29.9,29.9,0,0,0,3.445-1.642c1.852-.958,4.749-2.4,6.689-.958a2.217,2.217,0,0,1,.428,2.673,8.3,8.3,0,0,1-3.125,3.348c-2.737,1.876-6.157,1.167-9.128,2.311-.66.249-2.69,1.3-2.3,2.3.137.362.75.572,1.073.66a5.038,5.038,0,0,0,2.487.159c3.035-.66,5.248-3.26,8.355-3.767a5.745,5.745,0,0,1,4.217.96,2.426,2.426,0,0,1,.525,2.971,7.073,7.073,0,0,1-2.715,2.9,8.542,8.542,0,0,1-4.153,1.432c-2.986.234-6.045-1-8.766.708a1.781,1.781,0,0,0-.911,1.031c-.064.338.346.66.572.845a7.049,7.049,0,0,0,4.2,1.095,15.656,15.656,0,0,0,4.579-1.441,9.435,9.435,0,0,1,4.8-.684,2.9,2.9,0,0,1,2.666,2.165,4.252,4.252,0,0,1-1.231,3.244,9.972,9.972,0,0,1-3.648,2.648,9.6,9.6,0,0,1-4.886.388c-1.642-.21-3.244-.62-4.9-.757a3.5,3.5,0,0,1-1.192-.227,6.651,6.651,0,0,0-1.346-.5c-.386-.073-.344.41-.344.726,0,.757.94,1.19,1.505,1.512.53.291,1.006.7,1.554.958a12.962,12.962,0,0,0,2.013.7,9.4,9.4,0,0,1,3.783,1.763,3.753,3.753,0,0,1,.982,3.743c-.748,2.737-4.29,2.913-6.546,2.253a6.109,6.109,0,0,1-3.357-2.527c-1.07-1.505-1.642-3.244-3.22-4.226a1.88,1.88,0,0,0-.088,2.052A10.525,10.525,0,0,0,66.347,170c1.6,1.642,4.153,3.63,4.226,6.135a.677.677,0,0,1-.459.708,5.824,5.824,0,0,1-4.083.113,5.419,5.419,0,0,1-2.536-2.417c-1.046-1.779-1.642-4.017-3.059-5.595a4.375,4.375,0,0,0,.62,1.666,5.124,5.124,0,0,1,.3,3.445c-.41,1.781-1.8,3.268-3.7,2.377a6.77,6.77,0,0,1-2.439-2.417,8.706,8.706,0,0,1-1.231-3.558,11.933,11.933,0,0,1,.481-4.661c-3.035,2.326-8.009,3.928-9.973-.274-1.691-3.606,3.694-3.171,6.343-4.107-.435-.024-.845,0-1.256,0a34.74,34.74,0,0,1-3.518.066c-2.165-.113-4.193-1.161-4.4-3.56-.152-2.077,2.15-1.916,3.542-1.682,1.119.152,3.1.724,4.266.064-2.536-.894-5.361-1.867-6.8-4.242a5.43,5.43,0,0,1-.733-4.089c.371-1,1.578-.863,2.375-.565,2.15.775,3.719,2.642,5.82,3.56a13.479,13.479,0,0,0,1.578.523,5.294,5.294,0,0,0,.611.088c.073,0,.161-.04.234-.04a.362.362,0,0,0-.024-.137,2.71,2.71,0,0,0-.393-.821,3.907,3.907,0,0,0-1.435-1.441c-1.143-.708-2.4-1.119-3.494-1.894a6.3,6.3,0,0,1-2.375-3.606,6.859,6.859,0,0,1-.137-4.041,2.631,2.631,0,0,1,2.946-1.69c3.719.3,4.017,4.4,5.546,6.939a8.54,8.54,0,0,0,1.571,1.781c.234.225.918.892,1.28.8.21-.042.1-1.161.073-1.368a5.334,5.334,0,0,0-.982-2.512c-1.371-1.958-3.494-3.374-4.156-5.749-.435-1.569-.3-3.831,1.28-4.725,1.684-.958,3.745.483,4.606,1.916,1.095,1.8.894,4.315,2.56,5.731a3.6,3.6,0,0,0,.41-2.922,34.26,34.26,0,0,0-1.6-4.628,11.219,11.219,0,0,1-.982-4.615,4.251,4.251,0,0,1,2.536-3.533",
    transform: "translate(50.267 146.711)",
    fill: "#f9e4e6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5548",
    "data-name": "Path 5548",
    d: "M38.24,197.48H67.881l9.7-38.319H29.225Z",
    transform: "translate(35.272 192.097)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 54.147,
    height: 4.968,
    transform: "translate(61.92 346.288)",
    fill: "#f2c4c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5549",
    "data-name": "Path 5549",
    d: "M40.175,159.16H64.367l-9.7,38.319H40.175Z",
    transform: "translate(48.488 192.096)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 27.403,
    height: 4.968,
    transform: "translate(88.664 346.288)",
    fill: "#c11b20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5550",
    "data-name": "Path 5550",
    d: "M38.24,179.629H67.881l9.7-5.184H29.225Z",
    transform: "translate(35.272 210.543)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5551",
    "data-name": "Path 5551",
    d: "M40.175,174.445H64.367l-9.7,5.184H40.175Z",
    transform: "translate(48.488 210.543)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5552",
    "data-name": "Path 5552",
    d: "M135.641,112.767h33.384a3.138,3.138,0,0,0,3.284-2.962V108a3.143,3.143,0,0,0-3.284-2.968H135.641A3.128,3.128,0,0,0,132.357,108v1.805a3.123,3.123,0,0,0,3.284,2.962",
    transform: "translate(159.746 126.767)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5553",
    "data-name": "Path 5553",
    d: "M170.589,104.35a4.842,4.842,0,0,1,5.072,4.588v1.6a4.858,4.858,0,0,1-5.072,4.588H130.361v-1.529h40.228a3.248,3.248,0,0,0,3.405-3.059v-1.6a3.251,3.251,0,0,0-3.405-3.083H130.361V104.35Z",
    transform: "translate(157.337 125.944)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5554",
    "data-name": "Path 5554",
    d: "M133.67,112.767h35.783a1.989,1.989,0,0,0,2.077-1.867v-3.977a1.992,1.992,0,0,0-2.077-1.891H133.67a2,2,0,0,0-2.1,1.891V110.9a2,2,0,0,0,2.1,1.867",
    transform: "translate(158.795 126.767)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5555",
    "data-name": "Path 5555",
    d: "M135.641,117.513h33.384a3.138,3.138,0,0,0,3.284-2.962v-1.805a3.155,3.155,0,0,0-3.284-2.968H135.641a3.139,3.139,0,0,0-3.284,2.968v1.805a3.123,3.123,0,0,0,3.284,2.962",
    transform: "translate(159.746 132.495)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M170.589,109.1a4.842,4.842,0,0,1,5.072,4.588v1.593a4.842,4.842,0,0,1-5.072,4.59H130.361v-1.529h40.228a3.25,3.25,0,0,0,3.405-3.061v-1.593a3.251,3.251,0,0,0-3.405-3.083H130.361V109.1Z",
    transform: "translate(157.337 131.67)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5557",
    "data-name": "Path 5557",
    d: "M133.67,117.513h35.783a1.989,1.989,0,0,0,2.077-1.867v-3.977a1.992,1.992,0,0,0-2.077-1.891H133.67a2,2,0,0,0-2.1,1.891v3.977a2,2,0,0,0,2.1,1.867",
    transform: "translate(158.795 132.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5558",
    "data-name": "Path 5558",
    d: "M135.641,125.406h33.384a3.138,3.138,0,0,0,3.284-2.962v-4.816a3.145,3.145,0,0,0-3.284-2.971H135.641a3.13,3.13,0,0,0-3.284,2.971v4.816a3.123,3.123,0,0,0,3.284,2.962",
    transform: "translate(159.746 138.385)",
    fill: "#751219",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5559",
    "data-name": "Path 5559",
    d: "M170.589,113.976a4.838,4.838,0,0,1,5.072,4.564v4.63a4.838,4.838,0,0,1-5.072,4.564H130.361v-1.505h40.228a3.248,3.248,0,0,0,3.405-3.059v-4.63a3.248,3.248,0,0,0-3.405-3.059H130.361v-1.505Z",
    transform: "translate(157.337 137.562)",
    fill: "#e26971",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5560",
    "data-name": "Path 5560",
    d: "M133.67,125.406h35.783a1.989,1.989,0,0,0,2.077-1.867v-7a1.99,1.99,0,0,0-2.077-1.876H133.67a2,2,0,0,0-2.1,1.876v7a2,2,0,0,0,2.1,1.867",
    transform: "translate(158.795 138.385)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5561",
    "data-name": "Path 5561",
    d: "M138.272,106.2v4.017l-1.852-1.183V106.2Z",
    transform: "translate(164.65 128.175)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5562",
    "data-name": "Path 5562",
    d: "M135.581,106.2v4.017l1.852-1.183V106.2Z",
    transform: "translate(163.638 128.175)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5563",
    "data-name": "Path 5563",
    d: "M142.373,111.3v4.017l-1.827-1.192V111.3Z",
    transform: "translate(169.63 134.33)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5564",
    "data-name": "Path 5564",
    d: "M139.707,111.3v4.017l1.852-1.192V111.3Z",
    transform: "translate(168.617 134.33)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M136.941,116.19v5.385L134.454,120V116.19Z",
    transform: "translate(162.277 140.234)",
    fill: "#c11b20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M133.327,116.19v5.385L135.814,120V116.19Z",
    transform: "translate(160.917 140.234)",
    fill: "#f2c4c9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M145.1,83.255c-.523,7.252-1.593,8.258-8.508,8.83,6.914.547,7.985,1.545,8.508,8.808.532-7.263,1.6-8.261,8.517-8.808-6.914-.572-7.985-1.578-8.517-8.83M173.224,102.4c-.274,3.856-.845,4.4-4.542,4.7,3.7.3,4.268.821,4.542,4.7.3-3.88.861-4.4,4.54-4.7-3.679-.3-4.242-.845-4.54-4.7m-12.3-29.8c-.3,3.9-.87,4.451-4.612,4.74,3.743.322,4.315.845,4.612,4.776.274-3.931.87-4.454,4.588-4.776-3.719-.289-4.315-.836-4.588-4.74",
    transform: "translate(164.862 87.619)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M78.629,79.013c-.386,5.458-1.183,6.206-6.391,6.616,5.208.41,6.005,1.167,6.391,6.616.41-5.449,1.207-6.206,6.393-6.616-5.186-.41-5.983-1.159-6.393-6.616M99.741,93.365c-.205,2.924-.64,3.335-3.4,3.542,2.759.227,3.193.638,3.4,3.536.223-2.9.633-3.308,3.419-3.536-2.785-.207-3.2-.618-3.419-3.542M90.5,71c-.21,2.946-.636,3.332-3.443,3.558,2.807.234,3.233.644,3.443,3.591.225-2.946.662-3.357,3.469-3.591-2.807-.225-3.244-.611-3.469-3.558",
    transform: "translate(87.186 85.695)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M202.572,93.85c-.532,7.261-1.6,8.258-8.517,8.806,6.914.574,7.985,1.556,8.517,8.817.523-7.261,1.593-8.243,8.508-8.817-6.914-.547-7.985-1.545-8.508-8.806m28.112,19.127c-.3,3.88-.87,4.4-4.566,4.7,3.7.316,4.268.845,4.566,4.718.274-3.873.845-4.4,4.54-4.718-3.694-.3-4.266-.821-4.54-4.7m-12.326-29.8c-.274,3.92-.87,4.469-4.606,4.767,3.736.3,4.332.843,4.606,4.774.3-3.931.87-4.478,4.612-4.774-3.743-.3-4.315-.847-4.612-4.767",
    transform: "translate(234.212 100.387)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseHero);
export default __webpack_public_path__ + "static/media/enterprise-hero.cb0288b553296d0274d21034ab0a2d7d.svg";
export { ForwardRef as ReactComponent };